export const data = {
    'Learn the Basics' : {
        'Things to know in C++/Java/Python or any language' : [
            {
                id : '1.1-1',
                subTopic : 'Things to know in C++/Java/Python or any language',
                qnTitle : 'User Input / Output',
                gfg : null,
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '1.1-2',
                subTopic : 'Things to know in C++/Java/Python or any language',
                qnTitle : 'Data Types',
                gfg : 'https://bit.ly/3Dqmgvx',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '1.1-3',
                subTopic : 'Things to know in C++/Java/Python or any language',
                qnTitle : 'If Else Statements',
                gfg : 'https://practice.geeksforgeeks.org/problems/java-if-else-decision-making0924/0?category%5B%5D=Java&category%5B%5D=Java&difficulty%5B%5D=-2&page=1&query=category%5B%5DJavadifficulty%5B%5D-2page1category%5B%5DJava',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '1.1-4',
                subTopic : 'Things to know in C++/Java/Python or any language',
                qnTitle : 'Switch Statement',
                gfg : 'https://practice.geeksforgeeks.org/problems/java-switch-case-statement3529/1',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '1.1-5',
                subTopic : 'Things to know in C++/Java/Python or any language',
                qnTitle : 'What are arrays, strings?',
                gfg : null,
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '1.1-6',
                subTopic : 'Things to know in C++/Java/Python or any language',
                qnTitle : 'For loops',
                gfg : 'https://practice.geeksforgeeks.org/problems/for-loop-primecheck-java/1',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '1.1-7',
                subTopic : 'Things to know in C++/Java/Python or any language',
                qnTitle : 'While loops',
                gfg : null,
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '1.1-8',
                subTopic : 'Things to know in C++/Java/Python or any language',
                qnTitle : 'Functions (Pass by reference and value)',
                gfg : 'https://bit.ly/3DqE0ac',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '1.1-9',
                subTopic : 'Things to know in C++/Java/Python or any language',
                qnTitle : 'Time Complexity',
                gfg : null,
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            }
        ],
        'Build up Logical Thinking' : [
            {
                id : '1.2-1',
                subTopic : 'Build up Logical Thinking',
                qnTitle : 'Patterns',
                gfg : 'https://takeuforward.org/strivers-a2z-dsa-course/must-do-pattern-problems-before-starting-dsa/',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            }
        ],
        'Learn STL/Java-Collections or similar thing in your language' : [
            {
                id : '1.3-1',
                subTopic : 'Things to know in C++/Java/Python or any language',
                qnTitle : 'Time Complexity',
                gfg : null,
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            }
        ],
        'Know Basic Maths' : [
            {
                id : '1.4-1',
                subTopic : 'Know Basic Maths',
                qnTitle : 'Count Digits',
                gfg : 'https://practice.geeksforgeeks.org/problems/count-digits5716/1',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '1.4-2',
                subTopic : 'Know Basic Maths',
                qnTitle : 'Reverse a Number',
                gfg : 'https://practice.geeksforgeeks.org/problems/reverse-bits3556/1',
                leetcode : 'https://leetcode.com/problems/reverse-integer/',
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '1.4-3',
                subTopic : 'Know Basic Maths',
                qnTitle : 'Check Palindrome',
                gfg : 'https://practice.geeksforgeeks.org/problems/palindrome0746/1',
                leetcode : 'https://leetcode.com/problems/palindrome-number/',
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '1.4-4',
                subTopic : 'Know Basic Maths',
                qnTitle : 'GCD or HCF',
                gfg : 'https://practice.geeksforgeeks.org/problems/lcm-and-gcd4516/1',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '1.4-5',
                subTopic : 'Know Basic Maths',
                qnTitle : 'Armstrong Numbers',
                gfg : 'https://practice.geeksforgeeks.org/problems/armstrong-numbers2727/1',
                leetcode : 'https://leetcode.com/problems/armstrong-number/',
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '1.4-6',
                subTopic : 'Know Basic Maths',
                qnTitle : 'Print all Divisors',
                gfg : 'https://practice.geeksforgeeks.org/problems/sum-of-all-divisors-from-1-to-n4738/1',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '1.4-7',
                subTopic : 'Know Basic Maths',
                qnTitle : 'Check for Prime',
                gfg : 'https://practice.geeksforgeeks.org/problems/minimum-number-of-jumps-1587115620/1',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            }
        ],
        'Learn Basic Recursion' : [
            {
                id : '1.5-1',
                subTopic : 'Learn Basic Recursion',
                qnTitle : 'Print something N times',
                gfg : 'https://bit.ly/3K2epHv',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '1.5-2',
                subTopic : 'Learn Basic Recursion',
                qnTitle : 'Print name N times using recursion',
                gfg : 'https://bit.ly/3y2BiWz',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '1.5-3',
                subTopic : 'Learn Basic Recursion',
                qnTitle : 'Print 1 to N using recursion',
                gfg : 'https://bit.ly/3w3qhDh',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '1.5-4',
                subTopic : 'Learn Basic Recursion',
                qnTitle : 'Print N to 1 using recursion',
                gfg : 'https://bit.ly/3LOkcBn',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '1.5-5',
                subTopic : 'Learn Basic Recursion',
                qnTitle : 'Sum of first N numbers',
                gfg : 'https://bit.ly/3C9KZ8G',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '1.5-6',
                subTopic : 'Learn Basic Recursion',
                qnTitle : 'Factorial of N numbers',
                gfg : 'https://bit.ly/3QugUVo',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '1.5-7',
                subTopic : 'Learn Basic Recursion',
                qnTitle : 'Reverse an array',
                gfg : 'https://bit.ly/3SRqzXU',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '1.5-8',
                subTopic : 'Learn Basic Recursion',
                qnTitle : 'Check if a string is palindrome or not',
                gfg : 'https://bit.ly/3w2G4T5',
                leetcode : 'https://leetcode.com/problems/valid-palindrome/',
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '1.5-9',
                subTopic : 'Learn Basic Recursion',
                qnTitle : 'Fibonacci Number',
                gfg : 'https://bit.ly/3QUkkk2',
                leetcode : 'https://leetcode.com/problems/fibonacci-number/',
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            }    
        ],
        'Learn Basic Hashing' : [
            {
                id : '1.6-1',
                subTopic : 'Learn Basic Hashing',
                qnTitle : 'Hashing Theory',
                gfg : null,
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '1.6-2',
                subTopic : 'Learn Basic Hashing',
                qnTitle : 'Counting frequencies of array elements',
                gfg : 'https://practice.geeksforgeeks.org/problems/frequency-of-array-elements-1587115620/0',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '1.6-3',
                subTopic : 'Learn Basic Hashing',
                qnTitle : 'Find the highest/lowest frequency element',
                gfg : 'https://practice.geeksforgeeks.org/problems/top-k-frequent-elements-in-array/1',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            }
        ]

    },
    "Sorting" : {
        'Sorting-1' : [
            {
                id : '2.1-1',
                subTopic : 'Sorting-1',
                qnTitle : 'Selection Sort',
                gfg : 'https://bit.ly/3ppA6YJ',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '2.1-2',
                subTopic : 'Sorting-1',
                qnTitle : 'Bubble Sort',
                gfg : 'https://bit.ly/3w6yQx8',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '2.1-3',
                subTopic : 'Sorting-1',
                qnTitle : 'Insertion Sort',
                gfg : 'https://bit.ly/3JVcqot',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            }
        ],
        'Sorting-2' : [
            {
                id : '2.2-1',
                subTopic : 'Sorting-2',
                qnTitle : 'Merge Sort',
                gfg : 'https://bit.ly/3A30Anw',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '2.2-2',
                subTopic : 'Sorting-2',
                qnTitle : 'Recursive Bubble Sort',
                gfg : 'https://bit.ly/3QV65vI',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '2.2-3',
                subTopic : 'Sorting-2',
                qnTitle : 'Recursive Insertion Sort',
                gfg : 'https://bit.ly/3PxAWx1',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '2.2-4',
                subTopic : 'Sorting-2',
                qnTitle : 'Quick Sort',
                gfg : 'https://bit.ly/3dsEbIK',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            }
        ]
    },
    "Arrays" : {
        'Easy' : [
            {
                id : '3.1-1',
                subTopic : 'Easy',
                qnTitle : 'Largest Element in an Array',
                gfg : 'https://bit.ly/3Pld280',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '3.1-2',
                subTopic : 'Easy',
                qnTitle : 'Second Largest Element in an Array without Sorting',
                gfg : 'https://bit.ly/3pFvBcN',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '3.1-3',
                subTopic : 'Easy',
                qnTitle : 'Check if the array is sorted',
                gfg : 'https://bit.ly/3Ap9U6F',
                leetcode : 'https://leetcode.com/problems/check-if-array-is-sorted-and-rotated/#:~:text=Input%3A%20nums%20%3D%20%5B2%2C,no%20rotation)%20to%20make%20nums.',
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '3.1-4',
                subTopic : 'Easy',
                qnTitle : 'Remove duplicates from the sorted array',
                gfg : 'https://bit.ly/3w7b6ck',
                leetcode : 'https://leetcode.com/problems/remove-duplicates-from-sorted-array/#:~:text=Input%3A%20nums%20%3D%20%5B0%2C,%2C%203%2C%20and%204%20respectively.',
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '3.1-5',
                subTopic : 'Easy',
                qnTitle : 'Left Rotate an array by one place',
                gfg : 'https://bit.ly/3dnn9vC',
                leetcode : 'https://leetcode.com/problems/rotate-array/',
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '3.1-6',
                subTopic : 'Easy',
                qnTitle : 'Left Rotate an array by D places',
                gfg : 'https://bit.ly/3dyCKZg',
                leetcode : 'https://leetcode.com/problems/rotate-array/',
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '3.1-7',
                subTopic : 'Easy',
                qnTitle : 'Move Zeroes to end',
                gfg : 'https://bit.ly/3PrGIjT',
                leetcode : 'https://leetcode.com/problems/move-zeroes/',
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '3.1-8',
                subTopic : 'Easy',
                qnTitle : 'Linear Search',
                gfg : 'https://bit.ly/3KcpHcB',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '3.1-9',
                subTopic : 'Easy',
                qnTitle : 'Union and intersection of two sorted arrays',
                gfg : 'https://bit.ly/3Ap7Onp',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '3.1-10',
                subTopic : 'Easy',
                qnTitle : 'Find missing number in an array',
                gfg : 'https://bit.ly/3A2pKTh',
                leetcode : 'https://leetcode.com/problems/missing-number/',
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '3.1-11',
                subTopic : 'Easy',
                qnTitle : 'Maximum consecutive ones',
                gfg : 'https://bit.ly/3piuaAN',
                leetcode : 'https://leetcode.com/problems/max-consecutive-ones/',
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '3.1-12',
                subTopic : 'Easy',
                qnTitle : 'Find the number that appears once, and other numbers twice',
                gfg : 'https://bit.ly/3dudCD8',
                leetcode : 'https://leetcode.com/problems/single-number/',
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '3.1-14',
                subTopic : 'Easy',
                qnTitle : 'Longest subarray with given sum (Positives)',
                gfg : null,
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '3.1-15',
                subTopic : 'Easy',
                qnTitle : 'Longest subarray with given sum (Positives and Negatives)',
                gfg : 'https://bit.ly/3dyZdp3',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            }
        ],
        'Medium' : [
            {
                id : '3.2-1',
                subTopic : 'Medium',
                qnTitle : '2 Sum Problem',
                gfg : 'https://bit.ly/3SVYU8f',
                leetcode : 'https://leetcode.com/problems/two-sum/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '3.2-2',
                subTopic : 'Medium',
                qnTitle : "Sort an array of 0's, 1's and 2's",
                gfg : 'https://bit.ly/3dsROaZ',
                leetcode : 'https://leetcode.com/problems/sort-colors/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '3.2-3',
                subTopic : 'Medium',
                qnTitle : 'Majority Element (>n/2 times)',
                gfg : 'https://bit.ly/3SSpeA3',
                leetcode : 'https://leetcode.com/problems/majority-element/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '3.2-4',
                subTopic : 'Medium',
                qnTitle : 'Kadanes Algorithm',
                gfg : 'https://bit.ly/3dzyloY',
                leetcode : 'https://leetcode.com/problems/maximum-subarray/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '3.2-5',
                subTopic : 'Medium',
                qnTitle : 'Print the subarray with maximum sum',
                gfg : null,
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '3.2-6',
                subTopic : 'Medium',
                qnTitle : 'Stock Buy and Sell',
                gfg : 'https://bit.ly/3Qrx6H9',
                leetcode : 'https://leetcode.com/problems/best-time-to-buy-and-sell-stock/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '3.2-7',
                subTopic : 'Medium',
                qnTitle : 'Rearrange the array in alternating positive and negative items',
                gfg : 'https://bit.ly/3Qr3sSs',
                leetcode : 'https://leetcode.com/problems/rearrange-array-elements-by-sign/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '3.2-8',
                subTopic : 'Medium',
                qnTitle : 'Next permutation',
                gfg : 'https://bit.ly/3dug78u',
                leetcode : 'https://leetcode.com/problems/next-permutation/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '3.2-9',
                subTopic : 'Medium',
                qnTitle : 'Leaders in an array problem',
                gfg : 'https://bit.ly/3bZqbGc',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '3.2-10',
                subTopic : 'Medium',
                qnTitle : 'Longest consecutive sequence in an array',
                gfg : 'https://bit.ly/3ApytAD',
                leetcode : 'https://leetcode.com/problems/longest-consecutive-sequence/solution/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '3.2-11',
                subTopic : 'Medium',
                qnTitle : 'Set Matrix Zeroes',
                gfg : 'https://bit.ly/3SVaSig',
                leetcode : 'https://leetcode.com/problems/set-matrix-zeroes/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '3.2-12',
                subTopic : 'Medium',
                qnTitle : 'Rotate Matrix by 90 degrees',
                gfg : 'https://bit.ly/3PqpeV8',
                leetcode : 'https://leetcode.com/problems/rotate-image/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '3.2-13',
                subTopic : 'Medium',
                qnTitle : 'Print the matrix in spiral manner',
                gfg : 'https://bit.ly/3ppEJ53',
                leetcode : 'https://leetcode.com/problems/spiral-matrix/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '3.2-14',
                subTopic : 'Medium',
                qnTitle : 'Find the number of subarrays with sum K',
                gfg : 'http://bit.ly/3Kn10eZ',
                leetcode : 'https://leetcode.com/problems/subarray-sum-equals-k/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            }
        ],
        'Hard' : [
            {
                id : '3.3-1',
                subTopic : 'Hard',
                qnTitle : 'Pascal’s Triangle',
                gfg : 'https://bit.ly/3C95qlR',
                leetcode : 'https://leetcode.com/problems/pascals-triangle/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '3.3-2',
                subTopic : 'Hard',
                qnTitle : 'Majority Element (n/3 times)',
                gfg : 'https://bit.ly/3ULsluv',
                leetcode : 'https://leetcode.com/problems/majority-element-ii/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '3.3-3',
                subTopic : 'Hard',
                qnTitle : '3 Sum Problem',
                gfg : 'https://bit.ly/3C9uTvQ',
                leetcode : 'https://leetcode.com/problems/3sum/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '3.3-4',
                subTopic : 'Hard',
                qnTitle : '4 Sum Problem',
                gfg : 'https://bit.ly/3psQR53',
                leetcode : 'https://leetcode.com/problems/4sum/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '3.3-5',
                subTopic : 'Hard',
                qnTitle : 'Count Number of subarrays with given Xor K',
                gfg : 'https://bit.ly/3PrvhZs',
                leetcode : null,
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '3.3-6',
                subTopic : 'Hard',
                qnTitle : 'Merge Overlapping Subintervals',
                gfg : 'https://bit.ly/3zRz904',
                leetcode : 'https://leetcode.com/problems/merge-intervals/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '3.3-7',
                subTopic : 'Hard',
                qnTitle : 'Merge two sorted arrays without extra space',
                gfg : 'https://bit.ly/3zRzmAo',
                leetcode : 'https://leetcode.com/problems/merge-sorted-array/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '3.3-8',
                subTopic : 'Hard',
                qnTitle : 'Find the repeating and missing number',
                gfg : 'https://bit.ly/3zWZoCs',
                leetcode : null,
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '3.3-9',
                subTopic : 'Hard',
                qnTitle : 'Count Inversions',
                gfg : 'https://bit.ly/3PtLWLM',
                leetcode : null,
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '3.3-10',
                subTopic : 'Hard',
                qnTitle : 'Reverse Pairs',
                gfg : 'https://bit.ly/3UVC0hE',
                leetcode : 'https://leetcode.com/problems/reverse-pairs/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '3.3-11',
                subTopic : 'Hard',
                qnTitle : 'Maximum Product subarray',
                gfg : 'https://bit.ly/3PrlQsU',
                leetcode : 'https://leetcode.com/problems/maximum-product-subarray/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            }
        ]
    },
    "Binary Search" : {
        "Learning BS on 1D Arrays" : [
            {
                id : '4.1-1',
                subTopic : 'Learning BS on 1D Arrays"',
                qnTitle : 'Binary Search to find X in sorted array',
                gfg : 'https://bit.ly/3QtKBpO',
                leetcode : 'https://leetcode.com/problems/binary-search/',
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '4.1-2',
                subTopic : 'Learning BS on 1D Arrays"',
                qnTitle : 'Implement lower bound',
                gfg : 'https://bit.ly/3CgDDjE',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '4.1-3',
                subTopic : 'Learning BS on 1D Arrays"',
                qnTitle : 'Implement upper bound',
                gfg : 'https://bit.ly/3pFDbUN',
                leetcode : 'https://leetcode.com/problems/search-insert-position/#:~:text=Search%20Insert%20Position%20%2D%20LeetCode&text=Given%20a%20sorted%20array%20of,(log%20n)%20runtime%20complexity.',
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '4.1-4',
                subTopic : 'Learning BS on 1D Arrays"',
                qnTitle : 'Search Insert Position',
                gfg : 'https://bit.ly/3pFDbUN',
                leetcode : 'https://leetcode.com/problems/search-insert-position/#:~:text=Search%20Insert%20Position%20%2D%20LeetCode&text=Given%20a%20sorted%20array%20of,(log%20n)%20runtime%20complexity.',
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '4.1-5',
                subTopic : 'Learning BS on 1D Arrays"',
                qnTitle : 'Floor/Ceil in Sorted Array',
                gfg : null,
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '4.1-6',
                subTopic : 'Learning BS on 1D Arrays"',
                qnTitle : 'Find the first or last occurrence of a given number in a sorted array',
                gfg : 'https://bit.ly/3QuCFEP',
                leetcode : 'https://leetcode.com/problems/find-first-and-last-position-of-element-in-sorted-array/',
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '4.1-7',
                subTopic : 'Learning BS on 1D Arrays"',
                qnTitle : 'Count occurrences of a number in a sorted array with duplicates',
                gfg : 'https://bit.ly/3SVcOqW',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '4.1-8',
                subTopic : 'Learning BS on 1D Arrays"',
                qnTitle : 'Find the peak element',
                gfg : 'https://bit.ly/3Apsuf3',
                leetcode : 'https://leetcode.com/problems/find-peak-element/#:~:text=Find%20Peak%20Element%20%2D%20LeetCode&text=A%20peak%20element%20is%20an,to%20any%20of%20the%20peaks.',
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '4.1-9',
                subTopic : 'Learning BS on 1D Arrays"',
                qnTitle : 'Search in rotated sorted array 1',
                gfg : 'https://bit.ly/3QH471y',
                leetcode : 'https://leetcode.com/problems/search-in-rotated-sorted-array/',
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '4.1-10',
                subTopic : 'Learning BS on 1D Arrays"',
                qnTitle : 'Search in rotated sorted array 2',
                gfg : 'https://bit.ly/3Rm85Nb',
                leetcode : 'https://leetcode.com/problems/search-in-rotated-sorted-array-ii/',
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '4.1-11',
                subTopic : 'Learning BS on 1D Arrays"',
                qnTitle : 'Find minimum in rotated sorted array',
                gfg : 'https://bit.ly/3Az1OJ3',
                leetcode : 'https://leetcode.com/problems/find-minimum-in-rotated-sorted-array/',
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '4.1-12',
                subTopic : 'Learning BS on 1D Arrays"',
                qnTitle : 'Single Element in a sorted array',
                gfg : 'https://bit.ly/3AllLTj',
                leetcode : 'https://leetcode.com/problems/single-element-in-a-sorted-array/',
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '4.1-13',
                subTopic : 'Learning BS on 1D Arrays"',
                qnTitle : 'Find kth element of two sorted arrays',
                gfg : 'https://bit.ly/3Amcomr',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '4.1-14',
                subTopic : 'Learning BS on 1D Arrays"',
                qnTitle : 'Find out how many times has an array been rotated',
                gfg : 'https://bit.ly/3dEvWJD',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            }
        ],
        'Applying BS on 2D Arrays' : [
            {
                id : '4.2-1',
                subTopic : 'Applying BS on 2D Arrays"',
                qnTitle : 'Find the row with maximum number of 1’s',
                gfg : 'https://bit.ly/3QNDw2W',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '4.2-2',
                subTopic : 'Applying BS on 2D Arrays"',
                qnTitle : 'Search in a 2D matrix',
                gfg : 'https://bit.ly/3dAwi3Z',
                leetcode : 'https://leetcode.com/problems/search-a-2d-matrix/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '4.2-3',
                subTopic : 'Applying BS on 2D Arrays"',
                qnTitle : 'Find Peak Element',
                gfg : 'https://bit.ly/3A3mBmf',
                leetcode : 'https://leetcode.com/problems/find-a-peak-element-ii/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '4.2-4',
                subTopic : 'Applying BS on 2D Arrays"',
                qnTitle : 'Matrix Median',
                gfg : 'https://bit.ly/3PvwuPk',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            }
        ],
        'Find Answers by BS in Search Space' : [
            {
                id : '4.3-1',
                subTopic : 'Find Answers by BS in Search Space',
                qnTitle : 'Find square root of a number in log n',
                gfg : 'https://bit.ly/3JXtGcE',
                leetcode : null,
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '4.3-2',
                subTopic : 'Find Answers by BS in Search Space',
                qnTitle : 'Find the Nth root of a number using binary search',
                gfg : 'https://bit.ly/3zWNyrL',
                leetcode : null,
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '4.3-3',
                subTopic : 'Find Answers by BS in Search Space',
                qnTitle : 'Koko Eating Bananas',
                gfg : 'https://bit.ly/3LSY491',
                leetcode : 'https://leetcode.com/problems/koko-eating-bananas/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '4.3-4',
                subTopic : 'Find Answers by BS in Search Space',
                qnTitle : 'Minimum days to make M bouquets',
                gfg : 'https://bit.ly/3CJ9Ezm',
                leetcode : 'https://leetcode.com/problems/minimum-number-of-days-to-make-m-bouquets/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '4.3-5',
                subTopic : 'Find Answers by BS in Search Space',
                qnTitle : 'Find the smallest Divisor',
                gfg : 'https://bit.ly/3SJogFR',
                leetcode : 'https://leetcode.com/problems/find-the-smallest-divisor-given-a-threshold/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '4.3-6',
                subTopic : 'Find Answers by BS in Search Space',
                qnTitle : 'Capacity to Ship Packages within D Days',
                gfg : 'https://bit.ly/3PBInmS',
                leetcode : 'https://leetcode.com/problems/capacity-to-ship-packages-within-d-days/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '4.3-7',
                subTopic : 'Find Answers by BS in Search Space',
                qnTitle : '	Median of two sorted arrays',
                gfg : 'https://bit.ly/3K1HwL4',
                leetcode : 'https://leetcode.com/problems/median-of-two-sorted-arrays/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '4.3-8',
                subTopic : 'Find Answers by BS in Search Space',
                qnTitle : 'Aggressive Cows',
                gfg : 'https://bit.ly/3rBuE5Z',
                leetcode : null,
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '4.3-9',
                subTopic : 'Find Answers by BS in Search Space',
                qnTitle : 'Book Allocation Problem',
                gfg : 'https://bit.ly/3QMrMxP',
                leetcode : null,
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '4.3-10',
                subTopic : 'Find Answers by BS in Search Space',
                qnTitle : 'Split array – Largest Sum',
                gfg : 'https://bit.ly/3Qx0RGs',
                leetcode : 'https://leetcode.com/problems/split-array-largest-sum/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '4.3-11',
                subTopic : 'Find Answers by BS in Search Space',
                qnTitle : 'Kth Missing Positive Number',
                gfg : 'https://bit.ly/3bUFY9l',
                leetcode : 'https://leetcode.com/problems/kth-missing-positive-number/#:~:text=Given%20an%20array%20arr%20of,13%2C...%5D.',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '4.3-12',
                subTopic : 'Find Answers by BS in Search Space',
                qnTitle : 'Minimize Max Distance to Gas Station',
                gfg : 'https://bit.ly/3s40ybG',
                leetcode : 'https://leetcode.com/problems/minimize-max-distance-to-gas-station/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '4.3-13',
                subTopic : 'Find Answers by BS in Search Space',
                qnTitle : '	Median of 2 sorted arrays',
                gfg : 'https://bit.ly/3QPi7Xp',
                leetcode : 'https://leetcode.com/problems/median-of-two-sorted-arrays/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '4.3-14',
                subTopic : 'Find Answers by BS in Search Space',
                qnTitle : 'Kth element of 2 sorted arrays',
                gfg : 'https://bit.ly/3Amcomr',
                leetcode : null,
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            }
        ]
    },
    'Strings' : {
        'Basic and Easy String problems' : [
            {
                id : '5.1-1',
                subTopic : 'Basic and Easy String problems',
                qnTitle : 'Remove outermost Paranthesis',
                gfg : 'https://bit.ly/3rzwRix',
                leetcode : 'https://leetcode.com/problems/remove-outermost-parentheses/',
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '5.1-2',
                subTopic : 'Basic and Easy String problems',
                qnTitle : 'Reverse words in a given string / Palindrome Check',
                gfg : 'https://bit.ly/3SXyWB4',
                leetcode : 'https://leetcode.com/problems/reverse-words-in-a-string/',
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '5.1-3',
                subTopic : 'Basic and Easy String problems',
                qnTitle : 'Largest odd number in a string',
                gfg : 'https://bit.ly/3UII5yp',
                leetcode : 'https://leetcode.com/problems/largest-odd-number-in-string/',
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '5.1-4',
                subTopic : 'Basic and Easy String problems',
                qnTitle : '	Longest Common Prefix',
                gfg : 'https://bit.ly/3QKCyVu',
                leetcode : 'https://leetcode.com/problems/longest-common-prefix/',
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '5.1-5',
                subTopic : 'Basic and Easy String problems',
                qnTitle : '	Isomorphic String',
                gfg : 'https://bit.ly/3QwynwI',
                leetcode : 'https://leetcode.com/problems/isomorphic-strings/',
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '5.1-6',
                subTopic : 'Basic and Easy String problems',
                qnTitle : 'check whether one string is a rotation of another',
                gfg : 'https://bit.ly/3K0HHq5',
                leetcode : 'https://leetcode.com/problems/rotate-string/',
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '5.1-7',
                subTopic : 'Basic and Easy String problems',
                qnTitle : 'Check if two strings are anagram of each other',
                gfg : 'https://bit.ly/3SkMyoX',
                leetcode : 'https://leetcode.com/problems/valid-anagram/#:~:text=Given%20two%20strings%20s%20and,the%20original%20letters%20exactly%20once.&text=Constraints%3A,.length%20%3C%3D%205%20*%2010',
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            }
        ],
        'Medium String Problmes' : [
            {
                id : '5.2-1',
                subTopic : 'Medium String Problmes',
                qnTitle : 'Sort Characters by frequency',
                gfg : 'https://bit.ly/3dEQp1d',
                leetcode : 'https://leetcode.com/problems/sort-characters-by-frequency/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '5.2-2',
                subTopic : 'Medium String Problmes',
                qnTitle : 'Maximum Nesting Depth of Paranthesis',
                gfg : 'https://bit.ly/3xYlR1F',
                leetcode : 'https://leetcode.com/problems/maximum-nesting-depth-of-the-parentheses/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '5.2-3',
                subTopic : 'Medium String Problmes',
                qnTitle : 'Roman Number to Integer and vice versa',
                gfg : 'https://bit.ly/3AqBlNv',
                leetcode : 'https://leetcode.com/problems/roman-to-integer/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '5.2-4',
                subTopic : 'Medium String Problmes',
                qnTitle : 'Implement Atoi',
                gfg : 'https://bit.ly/3QUHBmf',
                leetcode : 'https://leetcode.com/problems/string-to-integer-atoi/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '5.2-5',
                subTopic : 'Medium String Problmes',
                qnTitle : 'Count Number of Substrings',
                gfg : 'https://bit.ly/3CfQfYi',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '5.2-6',
                subTopic : 'Medium String Problmes',
                qnTitle : 'Longest Palindromic Substring[Do it without DP]',
                gfg : 'https://bit.ly/3CeQ27D',
                leetcode : 'https://leetcode.com/problems/longest-palindromic-substring/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '5.2-7',
                subTopic : 'Medium String Problmes',
                qnTitle : 'Sum of Beauty of all substring',
                gfg : 'https://bit.ly/3LRh089',
                leetcode : 'https://leetcode.com/problems/sum-of-beauty-of-all-substrings/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '5.2-8',
                subTopic : 'Medium String Problmes',
                qnTitle : 'Reverse Every Word in A String',
                gfg : 'https://bit.ly/3Ul0iSq',
                leetcode : 'https://leetcode.com/problems/reverse-words-in-a-string/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            }
        ]
    },
    'LinkedList': {
        'Learn 1D LinkedList' : [
            {
                id : '6.1-1',
                subTopic : 'Learn 1D LinkedList',
                qnTitle : 'Introduction to LinkedList, learn about struct, and how is node represented',
                gfg : 'https://bit.ly/3URZnst',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '6.1-2',
                subTopic : 'Learn 1D LinkedList',
                qnTitle : 'Inserting a node in LinkedList',
                gfg : 'https://bit.ly/3w9pEIt',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '6.1-3',
                subTopic : 'Learn 1D LinkedList',
                qnTitle : 'Deleting a node in LinkedList',
                gfg : 'https://bit.ly/3Apg5aX',
                leetcode : 'https://leetcode.com/problems/delete-node-in-a-linked-list/',
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '6.1-4',
                subTopic : 'Learn 1D LinkedList',
                qnTitle : 'Find the length of the linkedlist [learn traversal]',
                gfg : 'https://bit.ly/3Po7tpf',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '6.1-5',
                subTopic : 'Learn 1D LinkedList',
                qnTitle : 'Search an element in the LL',
                gfg : 'https://bit.ly/3Epriup',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            }
        ],
        'Learn Doubly LinkedList' : [
            {
                id : '6.2-1',
                subTopic : 'Learn Doubly LinkedList',
                qnTitle : 'Introduction to DLL, learn about struct, and how is node represented',
                gfg : 'https://bit.ly/3V9wY1v',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '6.2-2',
                subTopic : 'Learn Doubly LinkedList',
                qnTitle : 'Insert a node in DLL',
                gfg : 'https://bit.ly/3QD4hHs',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '6.2-3',
                subTopic : 'Learn Doubly LinkedList',
                qnTitle : 'Delete a node in DLL',
                gfg : 'https://bit.ly/3QlEoMx',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '6.2-4',
                subTopic : 'Learn Doubly LinkedList',
                qnTitle : 'Reverse a DLL',
                gfg : 'https://bit.ly/3w6hUaa',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            }
        ],
        'Medium Problems on LL' : [
            {
                id : '6.3-1',
                subTopic : 'Medium Problems on LL',
                qnTitle : 'Middle of a LinkedList [TortoiseHare Method]',
                gfg : 'https://bit.ly/3dAjkn1',
                leetcode : 'https://leetcode.com/problems/middle-of-the-linked-list/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '6.3-2',
                subTopic : 'Medium Problems on LL',
                qnTitle : 'Reverse a LinkedList [Iterative]',
                gfg : 'https://bit.ly/3zY03mT',
                leetcode : 'https://leetcode.com/problems/reverse-linked-list/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '6.3-3',
                subTopic : 'Medium Problems on LL',
                qnTitle : 'Reverse a LL [Recursive]',
                gfg : 'https://bit.ly/3zY03mT',
                leetcode : 'https://leetcode.com/problems/reverse-linked-list/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '6.3-4',
                subTopic : 'Medium Problems on LL',
                qnTitle : 'Detect a loop in LL',
                gfg : 'https://bit.ly/3QN8PLn',
                leetcode : 'https://leetcode.com/problems/linked-list-cycle/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '6.3-5',
                subTopic : 'Medium Problems on LL',
                qnTitle : 'Find the starting point in LL',
                gfg : 'https://bit.ly/3zuBr66',
                leetcode : 'https://leetcode.com/problems/linked-list-cycle-ii/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '6.3-6',
                subTopic : 'Medium Problems on LL',
                qnTitle : 'Length of Loop in LL',
                gfg : 'https://bit.ly/3dyXL6m',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '6.3-7',
                subTopic : 'Medium Problems on LL',
                qnTitle : 'Check if LL is palindrome or not',
                gfg : 'https://bit.ly/3JVrnXJ',
                leetcode : 'https://leetcode.com/problems/palindrome-linked-list/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '6.3-8',
                subTopic : 'Medium Problems on LL',
                qnTitle : 'Segrregate odd and even nodes in LL',
                gfg : 'https://bit.ly/3A3aeqe',
                leetcode : 'https://leetcode.com/problems/odd-even-linked-list/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '6.3-9',
                subTopic : 'Medium Problems on LL',
                qnTitle : 'Remove Nth node from the back of the LL',
                gfg : 'https://bit.ly/3pobNKM',
                leetcode : 'https://leetcode.com/problems/remove-nth-node-from-end-of-list/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '6.3-10',
                subTopic : 'Medium Problems on LL',
                qnTitle : 'Delete the middle node of LL',
                gfg : 'https://bit.ly/3QzoU7W',
                leetcode : 'https://leetcode.com/problems/delete-the-middle-node-of-a-linked-list/#:~:text=You%20are%20given%20the%20head,than%20or%20equal%20to%20x%20.',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '6.3-11',
                subTopic : 'Medium Problems on LL',
                qnTitle : 'Sort LL',
                gfg : 'https://bit.ly/3dDuLdO',
                leetcode : 'https://leetcode.com/problems/sort-list/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '6.3-12',
                subTopic : 'Medium Problems on LL',
                qnTitle : 'Sort a LL of 0’s 1’s and 2’s by changing links',
                gfg : 'https://bit.ly/3Ceotvr',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '6.3-13',
                subTopic : 'Medium Problems on LL',
                qnTitle : '	Find the intersection point of Y LL',
                gfg : 'https://bit.ly/3pl5R4W',
                leetcode : 'https://leetcode.com/problems/intersection-of-two-linked-lists/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '6.3-14',
                subTopic : 'Medium Problems on LL',
                qnTitle : '	Add 1 to a number represented by LL',
                gfg : 'https://bit.ly/3piCTD3',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '6.3-15',
                subTopic : 'Medium Problems on LL',
                qnTitle : 'Add 2 numbers in LL',
                gfg : 'https://bit.ly/3JZlGb7',
                leetcode : 'https://leetcode.com/problems/add-two-numbers/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            }
        ],
        'Medium Problems of DLL' : [
            {
                id : '6.4-1',
                subTopic : 'Medium Problems of DLL',
                qnTitle : 'Delete all occurrences of a key in DLL',
                gfg : 'https://bit.ly/3zuBr66',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '6.4-2',
                subTopic : 'Medium Problems of DLL',
                qnTitle : 'Find pairs with given sum in DLL',
                gfg : 'https://bit.ly/3zWPiBj',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '6.4-3',
                subTopic : 'Medium Problems of DLL',
                qnTitle : 'Remove duplicates from sorted DLL',
                gfg : 'https://bit.ly/3FtJUtZ',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            }
        ],
        'Hard Problems of LL' : [
            {
                id : '6.5-1',
                subTopic : 'Hard Problems of LL',
                qnTitle : 'Reverse LL in group of given size K',
                gfg : 'https://bit.ly/3zWPiBj',
                leetcode : 'https://leetcode.com/problems/reverse-nodes-in-k-group/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '6.5-2',
                subTopic : 'Hard Problems of LL',
                qnTitle : 'Rotate a LL',
                gfg : 'https://bit.ly/3JXvemY',
                leetcode : 'https://leetcode.com/problems/rotate-list/description/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '6.5-3',
                subTopic : 'Hard Problems of LL',
                qnTitle : 'Flattening of LL',
                gfg : 'https://bit.ly/3w9TKf8',
                leetcode : null,
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '6.5-4',
                subTopic : 'Hard Problems of LL',
                qnTitle : 'Clone a Linked List with random and next pointer',
                gfg : 'https://bit.ly/3PpM6np',
                leetcode : 'https://leetcode.com/problems/copy-list-with-random-pointer/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            }
        ]
    },
    'Recursion' : {
        'Get a Strong Hold' : [
            {
                id : '7.1-1',
                subTopic : 'Get a Strong Hold',
                qnTitle : 'Recursive Implementation of atoi()',
                gfg : 'https://bit.ly/3K4ySLV',
                leetcode : 'https://leetcode.com/problems/string-to-integer-atoi/',
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '7.1-2',
                subTopic : 'Get a Strong Hold',
                qnTitle : 'Pow(x, n)',
                gfg : 'https://bit.ly/3QLc6uD',
                leetcode : 'https://leetcode.com/problems/powx-n/',
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '7.1-3',
                subTopic : 'Get a Strong Hold',
                qnTitle : 'Count Good numbers',
                gfg : 'https://bit.ly/3w6SucH',
                leetcode : 'https://leetcode.com/problems/count-good-numbers/',
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '7.1-4',
                subTopic : 'Get a Strong Hold',
                qnTitle : 'Sort a stack using recursion',
                gfg : 'https://bit.ly/3Pu0YBn',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '7.1-5',
                subTopic : 'Get a Strong Hold',
                qnTitle : 'Reverse a stack using recursion',
                gfg : 'https://bit.ly/3podAiY',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            }
        ],
        'Subsequences Pattern' : [
            {
                id : '7.2-1',
                subTopic : 'Subsequences Pattern',
                qnTitle : 'Generate all binary strings',
                gfg : 'https://bit.ly/3sI8I9W',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '7.2-2',
                subTopic : 'Subsequences Pattern',
                qnTitle : 'Generate Paranthesis',
                gfg : 'https://bit.ly/3K5keUw',
                leetcode : 'https://leetcode.com/problems/generate-parentheses/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '7.2-3',
                subTopic : 'Subsequences Pattern',
                qnTitle : 'Print all subsequences/Power Set',
                gfg : 'https://bit.ly/3STXz1t',
                leetcode : 'https://leetcode.com/problems/subsets/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '7.2-4',
                subTopic : 'Subsequences Pattern',
                qnTitle : 'Learn All Patterns of Subsequences (Theory)',
                gfg : 'https://bit.ly/3US225G',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '7.2-5',
                subTopic : 'Subsequences Pattern',
                qnTitle : 'Count all subsequences with sum K',
                gfg : 'https://bit.ly/3SVf1me',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '7.2-6',
                subTopic : 'Subsequences Pattern',
                qnTitle : 'Check if there exists a subsequence with sum K',
                gfg : 'https://bit.ly/3SVf1me',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '7.2-7',
                subTopic : 'Subsequences Pattern',
                qnTitle : 'Combination Sum',
                gfg : 'https://bit.ly/3C9bJ91',
                leetcode : 'https://leetcode.com/problems/combination-sum/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '7.2-8',
                subTopic : 'Subsequences Pattern',
                qnTitle : 'Combination Sum-II',
                gfg : 'https://bit.ly/3VgczZ2',
                leetcode : 'https://leetcode.com/problems/combination-sum-ii/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '7.2-9',
                subTopic : 'Subsequences Pattern',
                qnTitle : 'Subset Sum-I',
                gfg : 'https://bit.ly/3C9GQRS',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '7.2-10',
                subTopic : 'Subsequences Pattern',
                qnTitle : 'Subset Sum-II',
                gfg : 'https://bit.ly/3MlAvWF',
                leetcode : 'https://leetcode.com/problems/subsets-ii/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '7.2-11',
                subTopic : 'Subsequences Pattern',
                qnTitle : 'Combination Sum – III',
                gfg : 'https://bit.ly/3CMZFul',
                leetcode : 'https://leetcode.com/problems/combination-sum-iii/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '7.2-12',
                subTopic : 'Subsequences Pattern',
                qnTitle : 'Letter Combinations of a Phone number',
                gfg : 'https://bit.ly/3K1INBO',
                leetcode : 'https://leetcode.com/problems/letter-combinations-of-a-phone-number/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            }
        ],
        'Trying out all Combos' : [
            {
                id : '7.3-1',
                subTopic : 'Trying out all Combos',
                qnTitle : 'Palindrome Partitioning',
                gfg : 'https://bit.ly/3T63roP',
                leetcode : 'https://leetcode.com/problems/palindrome-partitioning/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '7.3-2',
                subTopic : 'Trying out all Combos',
                qnTitle : 'Word Search',
                gfg : 'https://bit.ly/3Ca9xOL',
                leetcode : 'https://leetcode.com/problems/word-search/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '7.3-3',
                subTopic : 'Trying out all Combos',
                qnTitle : 'N Queen',
                gfg : 'https://bit.ly/3QurLP8',
                leetcode : 'https://leetcode.com/problems/n-queens/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '7.3-4',
                subTopic : 'Trying out all Combos',
                qnTitle : 'Rat in a Maze',
                gfg : 'https://bit.ly/3pkqK0g',
                leetcode : null,
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '7.3-5',
                subTopic : 'Trying out all Combos',
                qnTitle : 'Word Break',
                gfg : 'https://bit.ly/3Bqk0Ug',
                leetcode : 'https://leetcode.com/problems/word-break/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '7.3-6',
                subTopic : 'Trying out all Combos',
                qnTitle : 'M Coloring Problem',
                gfg : 'https://bit.ly/3Cepqnv',
                leetcode : null,
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '7.3-7',
                subTopic : 'Trying out all Combos',
                qnTitle : 'Sudoko Solver',
                gfg : 'https://bit.ly/3PrA5hs',
                leetcode : 'https://leetcode.com/problems/sudoku-solver/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '7.3-8',
                subTopic : 'Trying out all Combos',
                qnTitle : 'Expression Add Operators',
                gfg : 'https://bit.ly/3yPPZN3',
                leetcode : 'https://leetcode.com/problems/expression-add-operators/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            }
        ]
    },
    'Bit Manipulation & Advanced Maths' : {
        'Learn Bit Manipulation' : [
            {
                id : '8.1-1',
                subTopic : 'Learn Bit Manipulation',
                qnTitle : 'Introduction to Bit Manipulation [Theory]',
                gfg : 'https://bit.ly/3Eo8JVW',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '8.1-2',
                subTopic : 'Learn Bit Manipulation',
                qnTitle : 'Check if the i-th bit is set or not',
                gfg : 'https://bit.ly/3C0kAJR',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '8.1-3',
                subTopic : 'Learn Bit Manipulation',
                qnTitle : 'Check if a number is odd or not',
                gfg : 'https://bit.ly/3xDMLvF',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '8.1-4',
                subTopic : 'Learn Bit Manipulation',
                qnTitle : 'Check if a number is power of 2 or not',
                gfg : 'https://bit.ly/3R1ZPlq',
                leetcode : 'https://leetcode.com/problems/power-of-two/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '8.1-5',
                subTopic : 'Learn Bit Manipulation',
                qnTitle : 'Count the number of set bits',
                gfg : 'https://bit.ly/3SbiBZ2',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '8.1-6',
                subTopic : 'Learn Bit Manipulation',
                qnTitle : 'Set/Unset the rightmost unset bit',
                gfg : 'https://bit.ly/3Sq66IM',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '8.1-7',
                subTopic : 'Learn Bit Manipulation',
                qnTitle : 'Swap two numbers',
                gfg : 'https://bit.ly/3qVixAz',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '8.1-8',
                subTopic : 'Learn Bit Manipulation',
                qnTitle : 'Divide two integers without using multiplication, division and mod operator',
                gfg : 'https://bit.ly/3LyUL6Q',
                leetcode : 'https://leetcode.com/problems/divide-two-integers/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            }
        ],
        'Interview Problems' : [
            {
                id : '8.2-1',
                subTopic : 'Interview Problems',
                qnTitle : 'Count number of bits to be flipped to convert A to B',
                gfg : 'https://bit.ly/3Skharj',
                leetcode : 'https://leetcode.com/problems/minimum-bit-flips-to-convert-number/',
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '8.2-2',
                subTopic : 'Interview Problems',
                qnTitle : '	Find the number that appears odd number of times',
                gfg : 'https://bit.ly/3BEb9ya',
                leetcode : 'https://leetcode.com/problems/single-number/',
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '8.2-3',
                subTopic : 'Interview Problems',
                qnTitle : 'Power Set',
                gfg : 'https://bit.ly/3fdHg04',
                leetcode : 'https://leetcode.com/problems/subsets/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '8.2-4',
                subTopic : 'Interview Problems',
                qnTitle : 'Fnd xor of numbers from L to R',
                gfg : 'https://bit.ly/3T8xUCf',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '8.2-5',
                subTopic : 'Interview Problems',
                qnTitle : 'Find the two numbers appearing odd number of times',
                gfg : 'https://bit.ly/3DK7O3i',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            }
        ],
        'Advanced Maths' : [
            {
                id : '8.3-1',
                subTopic : 'Advanced Maths',
                qnTitle : 'Print Prime Factors of a Number',
                gfg : 'https://bit.ly/3C165p8',
                leetcode : null,
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '8.3-2',
                subTopic : 'Advanced Maths',
                qnTitle : 'All Divisors of a Number',
                gfg : 'https://practice.geeksforgeeks.org/problems/all-divisors-of-a-number/1?utm_source=youtube&utm_medium=collab_striver_ytdescription&utm_campaign=all-divisors-of-a-number',
                leetcode : null,
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '8.3-3',
                subTopic : 'Advanced Maths',
                qnTitle : 'Sieve of Eratosthenes',
                gfg : 'https://bit.ly/3fduYVT',
                leetcode : 'https://leetcode.com/problems/count-primes/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '8.3-4',
                subTopic : 'Advanced Maths',
                qnTitle : 'Find Prime Factorisation of a Number using Sieve',
                gfg : 'https://bit.ly/3SPGzbK',
                leetcode : null,
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '8.3-5',
                subTopic : 'Advanced Maths',
                qnTitle : 'Power(n, x)',
                gfg : 'https://practice.geeksforgeeks.org/problems/power-of-numbers-1587115620/1?utm_source=youtube&utm_medium=collab_striver_ytdescription&utm_campaign=power-of-numbers',
                leetcode : 'https://leetcode.com/problems/powx-n/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            }
        ]
    },
    'Stack and Queues' : {
        'Learning' : [
            {
                id : '9.1-1',
                subTopic : 'Learning',
                qnTitle : 'Implement Stack using Arrays',
                gfg : 'https://bit.ly/3QPJ39w',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '9.1-2',
                subTopic : 'Learning',
                qnTitle : 'Implement Queue using Arrays',
                gfg : 'https://bit.ly/3C9HLli',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '9.1-3',
                subTopic : 'Learning',
                qnTitle : 'Implement Stack using Queue',
                gfg : 'https://bit.ly/3PrRI0F',
                leetcode : 'https://leetcode.com/problems/implement-stack-using-queues/',
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '9.1-4',
                subTopic : 'Learning',
                qnTitle : 'Implement Queue using Stack',
                gfg : 'https://bit.ly/3Quthki',
                leetcode : 'https://leetcode.com/problems/implement-queue-using-stacks/',
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '9.1-5',
                subTopic : 'Learning',
                qnTitle : 'Implement stack using Linkedlist',
                gfg : 'https://bit.ly/3w6PwVv',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '9.1-6',
                subTopic : 'Learning',
                qnTitle : 'Implement queue using Linkedlist',
                gfg : 'https://bit.ly/3PA7mY0',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '9.1-7',
                subTopic : 'Learning',
                qnTitle : 'Check for balanced paranthesis',
                gfg : 'https://bit.ly/3An2IIo',
                leetcode : 'https://leetcode.com/problems/valid-parentheses/',
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '9.1-8',
                subTopic : 'Learning',
                qnTitle : 'Implement Min Stack',
                gfg : 'https://bit.ly/3JVhFoe',
                leetcode : 'https://leetcode.com/problems/min-stack/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            }
        ],
        'Prefix, Infix, Postfix conversion problems' : [
            {
                id : '9.2-1',
                subTopic : 'Prefix, Infix, Postfix conversion problems',
                qnTitle : 'Infix to Postfix Conversion using Stack',
                gfg : 'https://bit.ly/3JWYj1P',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '9.2-2',
                subTopic : 'Prefix, Infix, Postfix conversion problems',
                qnTitle : 'Prefix to Infix Conversion',
                gfg : 'https://bit.ly/3FwxK3j',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '9.2-3',
                subTopic : 'Prefix, Infix, Postfix conversion problems',
                qnTitle : '	Prefix to Postfix Conversion',
                gfg : 'https://bit.ly/3DrwCLI',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '9.2-4',
                subTopic : 'Prefix, Infix, Postfix conversion problems',
                qnTitle : 'Postfix to Prefix Conversion',
                gfg : 'https://bit.ly/3UaWJxk',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '9.2-5',
                subTopic : 'Prefix, Infix, Postfix conversion problems',
                qnTitle : 'Postfix to Infix',
                gfg : 'https://bit.ly/3sNZ1a2',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '9.2-6',
                subTopic : 'Prefix, Infix, Postfix conversion problems',
                qnTitle : 'Convert Infix To Prefix Notation',
                gfg : 'https://bit.ly/3T0gZ4P',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            }
        ],
        'Monotonic Stack/Queue Problems (VVV. Imp)' : [
            {
                id : '9.3-1',
                subTopic : 'Monotonic Stack/Queue Problems (VVV. Imp)',
                qnTitle : 'Next Greater Element',
                gfg : 'https://bit.ly/3QNPQAs',
                leetcode : 'https://leetcode.com/problems/next-greater-element-i/',
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '9.3-2',
                subTopic : 'Monotonic Stack/Queue Problems (VVV. Imp)',
                qnTitle : 'Next Greater Element 2',
                gfg : 'https://bit.ly/3DLe7TX',
                leetcode : 'https://leetcode.com/problems/next-greater-element-ii/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '9.3-3',
                subTopic : 'Monotonic Stack/Queue Problems (VVV. Imp)',
                qnTitle : 'Next Smaller Element',
                gfg : 'https://bit.ly/3wbhcIL',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '9.3-4',
                subTopic : 'Monotonic Stack/Queue Problems (VVV. Imp)',
                qnTitle : 'Number of NGEs to the right',
                gfg : 'https://bit.ly/3Np2R2H',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '9.3-5',
                subTopic : 'Monotonic Stack/Queue Problems (VVV. Imp)',
                qnTitle : 'Trapping Rainwater',
                gfg : 'https://bit.ly/3AqMa1W',
                leetcode : 'https://leetcode.com/problems/trapping-rain-water/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '9.3-6',
                subTopic : 'Monotonic Stack/Queue Problems (VVV. Imp)',
                qnTitle : 'Sum of subarray minimum',
                gfg : 'https://bit.ly/3yS5XpZ',
                leetcode : 'https://leetcode.com/problems/sum-of-subarray-minimums/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '9.3-7',
                subTopic : 'Monotonic Stack/Queue Problems (VVV. Imp)',
                qnTitle : 'Stock span problem',
                gfg : 'https://bit.ly/3dzHopW',
                leetcode : 'https://leetcode.com/problems/online-stock-span/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '9.3-8',
                subTopic : 'Monotonic Stack/Queue Problems (VVV. Imp)',
                qnTitle : 'Asteroid Collision',
                gfg : 'https://bit.ly/3Tpi0Tw',
                leetcode : 'https://leetcode.com/problems/asteroid-collision/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '9.3-9',
                subTopic : 'Monotonic Stack/Queue Problems (VVV. Imp)',
                qnTitle : 'Sum of subarray ranges',
                gfg : 'https://bit.ly/3SdfheS',
                leetcode : 'https://leetcode.com/problems/sum-of-subarray-ranges/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '9.3-10',
                subTopic : 'Monotonic Stack/Queue Problems (VVV. Imp)',
                qnTitle : 'Remove k Digits',
                gfg : 'https://bit.ly/3pl6taP',
                leetcode : 'https://leetcode.com/problems/remove-k-digits/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '9.3-11',
                subTopic : 'Monotonic Stack/Queue Problems (VVV. Imp)',
                qnTitle : 'Largest rectangle in a histogram',
                gfg : 'https://bit.ly/3AnVYd5',
                leetcode : 'https://leetcode.com/problems/largest-rectangle-in-histogram/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '9.3-12',
                subTopic : 'Monotonic Stack/Queue Problems (VVV. Imp)',
                qnTitle : 'Maximal Rectangles',
                gfg : 'https://bit.ly/3C6BF5p',
                leetcode : 'https://leetcode.com/problems/maximal-rectangle/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            }
        ],
        'Implementation Problems' : [
            {
                id : '9.4-1',
                subTopic : 'Implementation Problems',
                qnTitle : 'Sliding Window maximum',
                gfg : 'https://bit.ly/3w7SSri',
                leetcode : 'https://leetcode.com/problems/sliding-window-maximum/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '9.4-2',
                subTopic : 'Implementation Problems',
                qnTitle : 'Stock Span Problem',
                gfg : 'https://bit.ly/3SSxcZZ',
                leetcode : 'https://leetcode.com/problems/online-stock-span/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '9.4-3',
                subTopic : 'Implementation Problems',
                qnTitle : 'The Celebrity Problem',
                gfg : 'https://bit.ly/3dC9IIB',
                leetcode : 'https://leetcode.com/accounts/login/?next=/problems/find-the-celebrity/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '9.4-4',
                subTopic : 'Implementation Problems',
                qnTitle : 'Rotten Oranges',
                gfg : 'https://bit.ly/3R4htWb',
                leetcode : 'https://leetcode.com/problems/rotting-oranges/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '9.4-5',
                subTopic : 'Implementation Problems',
                qnTitle : 'LRU cache (IMPORTANT)',
                gfg : 'https://bit.ly/3zZneNN',
                leetcode : 'https://leetcode.com/problems/lru-cache/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '9.4-6',
                subTopic : 'Implementation Problems',
                qnTitle : 'LFU cache',
                gfg : 'https://bit.ly/3fpYDLQ',
                leetcode : 'https://leetcode.com/problems/lfu-cache/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            }
        ]
    },
    'Sliding Window & Two Pointer Combined Problems' : {
        'Medium Problems' : [
            {
                id : '10.1-1',
                subTopic : 'Medium Problems',
                qnTitle : 'Longest Substring Without Repeating Characters',
                gfg : 'https://bit.ly/3wegomm',
                leetcode : 'https://leetcode.com/problems/longest-substring-without-repeating-characters/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '10.1-2',
                subTopic : 'Medium Problems',
                qnTitle : 'Max Consecutive Ones III',
                gfg : 'https://bit.ly/3RjRcCO',
                leetcode : 'https://leetcode.com/problems/max-consecutive-ones-iii/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '10.1-3',
                subTopic : 'Medium Problems',
                qnTitle : '	Fruit Into Baskets',
                gfg : 'https://bit.ly/3D6d94w',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '10.1-4',
                subTopic : 'Medium Problems',
                qnTitle : 'longest repeating character replacement',
                gfg : 'https://bit.ly/3WhN89U',
                leetcode : 'https://leetcode.com/problems/longest-repeating-character-replacement/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '10.1-5',
                subTopic : 'Medium Problems',
                qnTitle : 'Binary subarray with sum',
                gfg : 'https://bit.ly/3S8xsCG',
                leetcode : 'https://leetcode.com/problems/binary-subarrays-with-sum/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '10.1-6',
                subTopic : 'Medium Problems',
                qnTitle : 'Count number of nice subarrays',
                gfg : 'https://bit.ly/3xZvUUc',
                leetcode : 'https://leetcode.com/problems/count-number-of-nice-subarrays/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '10.1-7',
                subTopic : 'Medium Problems',
                qnTitle : 'Number of substring containing all three characters',
                gfg : 'https://bit.ly/3xVYTZa',
                leetcode : 'https://leetcode.com/problems/number-of-substrings-containing-all-three-characters/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '10.1-8',
                subTopic : 'Medium Problems',
                qnTitle : 'Maximum point you can obtain from cards',
                gfg : 'https://bit.ly/3DxaMXw',
                leetcode : 'https://leetcode.com/problems/maximum-points-you-can-obtain-from-cards/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            }
        ],
        'Hard Problems' : [
            {
                id : '10.2-1',
                subTopic : 'Hard Problems',
                qnTitle : 'Longest Substring with At Most K Distinct Characters',
                gfg : 'https://bit.ly/3T12HRu',
                leetcode : 'https://leetcode.com/problems/longest-substring-with-at-most-k-distinct-characters/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '10.2-2',
                subTopic : 'Hard Problems',
                qnTitle : 'Subarray with k different integers',
                gfg : 'https://bit.ly/3DLRtee',
                leetcode : 'https://leetcode.com/problems/subarrays-with-k-different-integers/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '10.2-3',
                subTopic : 'Hard Problems',
                qnTitle : 'Minimum Window Substring',
                gfg : 'https://practice.geeksforgeeks.org/problems/smallest-window-in-a-string-containing-all-the-characters-of-another-string-1587115621/1',
                leetcode : 'https://leetcode.com/problems/minimum-window-substring/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '10.2-4',
                subTopic : 'Hard Problems',
                qnTitle : 'Minimum Window Subsequence',
                gfg : 'https://bit.ly/3DnB4uZ',
                leetcode : 'https://leetcode.com/problems/minimum-window-subsequence/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            }
        ]
    },
    'Heaps' : {
        'Learning' : [
            {
                id : '11.1-1',
                subTopic : 'Learning',
                qnTitle : 'Introduction to Priority Queues using Binary Heaps',
                gfg : 'https://bit.ly/3TSxAHd',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '11.1-2',
                subTopic : 'Learning',
                qnTitle : 'Min Heap and Max Heap Implementation',
                gfg : 'https://bit.ly/3weGgP3',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '11.1-3',
                subTopic : 'Learning',
                qnTitle : 'Check if an array represents a min-heap or not',
                gfg : 'https://bit.ly/3AbFrrI',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '11.1-4',
                subTopic : 'Learning',
                qnTitle : 'Convert min Heap to max Heap',
                gfg : 'https://bit.ly/3flmw7c',
                leetcode : '',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            }
        ],
        'Medium Problems' : [
            {
                id : '11.2-1',
                subTopic : 'Medium Problems',
                qnTitle : 'Kth largest element in an array [use priority queue]',
                gfg : 'https://bit.ly/3Avss5k',
                leetcode : 'https://leetcode.com/problems/kth-largest-element-in-an-array/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '11.2-2',
                subTopic : 'Medium Problems',
                qnTitle : 'Kth smallest element in an array [use priority queue]',
                gfg : 'https://bit.ly/3PvAOhK',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '11.2-3',
                subTopic : 'Medium Problems',
                qnTitle : 'Sort K sorted array',
                gfg : 'https://bit.ly/3QLpaAs',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '11.2-4',
                subTopic : 'Medium Problems',
                qnTitle : 'Merge M sorted Lists',
                gfg : 'https://bit.ly/3QObTXC',
                leetcode : 'https://leetcode.com/problems/merge-k-sorted-lists/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '11.2-5',
                subTopic : 'Medium Problems',
                qnTitle : 'Replace each array element by its corresponding rank',
                gfg : 'https://bit.ly/3TS3jcg',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '11.2-6',
                subTopic : 'Medium Problems',
                qnTitle : 'Task Scheduler',
                gfg : 'https://bit.ly/3h2Z92Z',
                leetcode : 'https://leetcode.com/problems/task-scheduler/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '11.2-7',
                subTopic : 'Medium Problems',
                qnTitle : 'Hands of Straights',
                gfg : 'https://bit.ly/3SUfwM8',
                leetcode : 'https://leetcode.com/problems/hand-of-straights/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            }
        ],
        'Hard Problems' : [
            {
                id : '11.3-1',
                subTopic : 'Hard Problems',
                qnTitle : 'Design twitter',
                gfg : 'https://practice.geeksforgeeks.org/problems/design-twitter/1',
                leetcode : 'https://leetcode.com/problems/design-twitter/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '11.3-2',
                subTopic : 'Hard Problems',
                qnTitle : "Connect 'n' ropes with minimal cost",
                gfg : 'https://bit.ly/3t5CS7r',
                leetcode : null,
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '11.3-3',
                subTopic : 'Hard Problems',
                qnTitle : 'Kth largest element in a stream of running integers',
                gfg : 'https://bit.ly/3JZPqEV',
                leetcode : 'https://leetcode.com/problems/kth-largest-element-in-a-stream/#:~:text=Implement%20KthLargest%20class%3A,largest%20element%20in%20the%20stream.',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '11.3-4',
                subTopic : 'Hard Problems',
                qnTitle : 'Maximum Sum Combination',
                gfg : 'https://bit.ly/3sSXvTT',
                leetcode : null,
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '11.3-5',
                subTopic : 'Hard Problems',
                qnTitle : 'Find Median from Data Stream',
                gfg : 'https://bit.ly/3QIknj4',
                leetcode : 'https://leetcode.com/problems/find-median-from-data-stream/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '11.3-6',
                subTopic : 'Hard Problems',
                qnTitle : 'K most frequent elements',
                gfg : 'https://bit.ly/3wcIHla',
                leetcode : 'https://leetcode.com/problems/top-k-frequent-elements/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            }
        ]
    },
    'Greedy Algorithms' : {
        'Easy Problems' : [
            {
                id : '12.1-1',
                subTopic : 'Easy Problems',
                qnTitle : 'Assign Cookies',
                gfg : 'https://bit.ly/3Wl3PBd',
                leetcode : 'https://leetcode.com/problems/assign-cookies/',
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '12.1-2',
                subTopic : 'Easy Problems',
                qnTitle : 'Fractional Knapsack Problem',
                gfg : 'https://bit.ly/3PsqOFL',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '12.1-3',
                subTopic : 'Easy Problems',
                qnTitle : 'Greedy algorithm to find minimum number of coins',
                gfg : 'https://bit.ly/3Ka7xYU',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '12.1-4',
                subTopic : 'Easy Problems',
                qnTitle : 'Lemonade Change',
                gfg : 'https://bit.ly/3DoFGRx',
                leetcode : 'https://leetcode.com/problems/lemonade-change/',
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '12.1-5',
                subTopic : 'Easy Problems',
                qnTitle : 'Valid Paranthesis Checker',
                gfg : 'https://bit.ly/3K6ulZA',
                leetcode : 'https://leetcode.com/problems/valid-parenthesis-string/',
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            }
        ],
        'Medium/Hard' : [
            {
                id : '12.2-1',
                subTopic : 'Medium/Hard',
                qnTitle : 'N meetings in one room',
                gfg : 'https://bit.ly/3A6Ob1Y',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '12.2-2',
                subTopic : 'Medium/Hard',
                qnTitle : 'Jump Game',
                gfg : 'https://bit.ly/3AbFYKe',
                leetcode : 'https://leetcode.com/problems/jump-game/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '12.2-3',
                subTopic : 'Medium/Hard',
                qnTitle : 'Jump Game 2',
                gfg : 'https://bit.ly/3Av2ezM',
                leetcode : 'https://leetcode.com/problems/jump-game-ii/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '12.2-4',
                subTopic : 'Medium/Hard',
                qnTitle : 'Minimum number of platforms required for a railway',
                gfg : 'https://bit.ly/3bXX5Hm',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '12.2-5',
                subTopic : 'Medium/Hard',
                qnTitle : 'Job sequencing Problem',
                gfg : 'https://bit.ly/3Pttpzj',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '12.2-6',
                subTopic : 'Medium/Hard',
                qnTitle : 'Candy',
                gfg : 'https://bit.ly/3h14wzm',
                leetcode : 'https://leetcode.com/problems/candy/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '12.2-7',
                subTopic : 'Medium/Hard',
                qnTitle : 'Program for Shortest Job First (or SJF) CPU Scheduling',
                gfg : 'https://bit.ly/3DYCIFb',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '12.2-8',
                subTopic : 'Medium/Hard',
                qnTitle : 'Program for Least Recently Used (LRU) Page Replacement Algorithm',
                gfg : 'https://bit.ly/3dtFqHG',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '12.2-9',
                subTopic : 'Medium/Hard',
                qnTitle : 'Insert Interval',
                gfg : 'https://bit.ly/3VeNtc1',
                leetcode : 'https://leetcode.com/problems/insert-interval/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '12.2-10',
                subTopic : 'Medium/Hard',
                qnTitle : 'Merge Intervals',
                gfg : 'https://bit.ly/3K6pRlt',
                leetcode : 'https://leetcode.com/problems/merge-intervals/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '12.2-11',
                subTopic : 'Medium/Hard',
                qnTitle : 'Non-overlapping Intervals',
                gfg : 'https://bit.ly/3UM6liN',
                leetcode : 'https://leetcode.com/problems/non-overlapping-intervals/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            }
        ]
    },
    'Binary Trees' : {
        'Traversals' : [
            {
                id : '13.1-1',
                subTopic : 'Traversals',
                qnTitle : 'Introduction to Trees',
                gfg : 'https://bit.ly/3EsRmTM',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '13.1-2',
                subTopic : 'Traversals',
                qnTitle : 'Binary Tree Representation in C++',
                gfg : 'https://bit.ly/3gn5Soh',
                leetcode :  null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '13.1-3',
                subTopic : 'Traversals',
                qnTitle : 'Binary Tree Representation in Java',
                gfg : 'https://bit.ly/3gn5Soh',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '13.1-4',
                subTopic : 'Traversals',
                qnTitle : 'Binary Tree Traversals in Binary Tree',
                gfg : 'https://bit.ly/3Cb4VIh',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '13.1-5',
                subTopic : 'Traversals',
                qnTitle : 'Preorder Traversal of Binary Tree',
                gfg : 'https://bit.ly/3Cb4VIh',
                leetcode : 'https://leetcode.com/problems/binary-tree-preorder-traversal/',
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '13.1-6',
                subTopic : 'Traversals',
                qnTitle : 'Inorder Traversal of Binary Tree',
                gfg : 'https://bit.ly/3QzNDbU',
                leetcode : 'https://leetcode.com/problems/binary-tree-inorder-traversal/',
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '13.1-7',
                subTopic : 'Traversals',
                qnTitle : 'Post-order Traversal of Binary Tree',
                gfg : 'https://bit.ly/3SZauQ4',
                leetcode : 'https://leetcode.com/problems/binary-tree-postorder-traversal/',
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '13.1-8',
                subTopic : 'Traversals',
                qnTitle : 'Level order Traversal / Level order traversal in spiral form',
                gfg : 'https://bit.ly/3K6t9VR',
                leetcode : 'https://leetcode.com/problems/binary-tree-level-order-traversal/',
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '13.1-9',
                subTopic : 'Traversals',
                qnTitle : 'Iterative Preorder Traversal of Binary Tree',
                gfg : 'https://bit.ly/3Cb4VIh',
                leetcode : 'https://leetcode.com/problems/binary-tree-preorder-traversal/',
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '13.1-10',
                subTopic : 'Traversals',
                qnTitle : 'Iterative Inorder Traversal of Binary Tree',
                gfg : 'https://bit.ly/3QzNDbU',
                leetcode : 'https://leetcode.com/problems/binary-tree-inorder-traversal/',
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '13.1-11',
                subTopic : 'Traversals',
                qnTitle : 'Post-order Traversal of Binary Tree using 2 stack',
                gfg : 'https://bit.ly/3Cb5Wjz',
                leetcode : 'https://leetcode.com/problems/binary-tree-postorder-traversal/',
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '13.1-12',
                subTopic : 'Traversals',
                qnTitle : 'Post-order Traversal of Binary Tree using 1 stack',
                gfg : 'https://bit.ly/3SZauQ4',
                leetcode : 'https://leetcode.com/problems/binary-tree-postorder-traversal/',
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '13.1-13',
                subTopic : 'Traversals',
                qnTitle : 'Preorder, Inorder, and Postorder Traversal in one Traversal',
                gfg : 'https://bit.ly/3T3oW9M',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            }
        ],
        'Medium Problems' : [
            {
                id : '13.2-1',
                subTopic : 'Medium Problems',
                qnTitle : 'Height of a Binary Tree',
                gfg : 'https://bit.ly/3CitiDM',
                leetcode : 'https://leetcode.com/problems/maximum-depth-of-binary-tree/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '13.2-2',
                subTopic : 'Medium Problems',
                qnTitle : 'Check if the Binary tree is height-balanced or not',
                gfg : 'https://bit.ly/3K9YbfB',
                leetcode : 'https://leetcode.com/problems/balanced-binary-tree/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '13.2-3',
                subTopic : 'Medium Problems',
                qnTitle : 'Diameter of Binary Tree',
                gfg : 'https://bit.ly/3wcfG9l',
                leetcode : 'https://leetcode.com/problems/diameter-of-binary-tree/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '13.2-4',
                subTopic : 'Medium Problems',
                qnTitle : 'Maximum path sum',
                gfg : 'https://bit.ly/3QAFjbW',
                leetcode : 'https://leetcode.com/problems/binary-tree-maximum-path-sum/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '13.2-5',
                subTopic : 'Medium Problems',
                qnTitle : 'Check if two trees are identical or not',
                gfg : 'https://bit.ly/3c2K52Z',
                leetcode : 'https://leetcode.com/problems/same-tree/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '13.2-6',
                subTopic : 'Medium Problems',
                qnTitle : 'Zig Zag Traversal of Binary Tree',
                gfg : 'https://bit.ly/3K4mwn5',
                leetcode : 'https://leetcode.com/problems/binary-tree-zigzag-level-order-traversal/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '13.2-7',
                subTopic : 'Medium Problems',
                qnTitle : 'Boundary Traversal of Binary Tree',
                gfg : 'https://bit.ly/3AsfgOK',
                leetcode : 'https://leetcode.com/problems/boundary-of-binary-tree/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '13.2-8',
                subTopic : 'Medium Problems',
                qnTitle : 'Vertical Order Traversal of Binary Tree',
                gfg : 'https://bit.ly/3pqu1er',
                leetcode : 'https://leetcode.com/problems/vertical-order-traversal-of-a-binary-tree/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '13.2-9',
                subTopic : 'Medium Problems',
                qnTitle : 'Top View of Binary Tree',
                gfg : 'https://bit.ly/3PsvE5T',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '13.2-10',
                subTopic : 'Medium Problems',
                qnTitle : 'Bottom View of Binary Tree',
                gfg : 'https://bit.ly/3Asftl0',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '13.2-11',
                subTopic : 'Medium Problems',
                qnTitle : 'Right/Left View of Binary Tree',
                gfg : 'https://bit.ly/3PCqyE9',
                leetcode : 'https://leetcode.com/problems/binary-tree-right-side-view/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '13.2-12',
                subTopic : 'Medium Problems',
                qnTitle : 'Symmetric Binary Tree',
                gfg : 'https://bit.ly/3PCqBzP',
                leetcode : 'https://leetcode.com/problems/symmetric-tree/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            }
        ],
        'Hard Problems' : [
            {
                id : '13.3-1',
                subTopic : 'Hard Problems',
                qnTitle : 'Root to Node Path in Binary Tree',
                gfg : 'https://bit.ly/3QA600D',
                leetcode : 'https://www.interviewbit.com/problems/path-to-given-node/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '13.3-2',
                subTopic : 'Hard Problems',
                qnTitle : 'LCA in Binary Tree',
                gfg : 'https://bit.ly/3popvgG',
                leetcode : 'https://leetcode.com/problems/lowest-common-ancestor-of-a-binary-tree/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '13.3-3',
                subTopic : 'Hard Problems',
                qnTitle : 'Maximum width of a Binary Tree',
                gfg : 'https://bit.ly/3dxUfZP',
                leetcode : 'https://leetcode.com/problems/maximum-width-of-binary-tree/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '13.3-4',
                subTopic : 'Hard Problems',
                qnTitle : '	Check for Children Sum Property',
                gfg : 'https://bit.ly/3dEr73g',
                leetcode : null,
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '13.3-5',
                subTopic : 'Hard Problems',
                qnTitle : 'Print all the Nodes at a distance of K in a Binary Tree',
                gfg : 'https://bit.ly/3QytIu6',
                leetcode : 'https://leetcode.com/problems/all-nodes-distance-k-in-binary-tree/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '13.3-6',
                subTopic : 'Hard Problems',
                qnTitle : 'Minimum time taken to BURN the Binary Tree from a Node',
                gfg : 'https://bit.ly/3wcg7k1',
                leetcode : 'https://www.codingninjas.com/codestudio/problems/time-to-burn-tree_630563?source=youtube&campaign=Striver_Tree_Videos&utm_source=youtube&utm_medium=affiliate&utm_campaign=Striver_Tree_Videos',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '13.3-7',
                subTopic : 'Hard Problems',
                qnTitle : 'Count total Nodes in a COMPLETE Binary Tree',
                gfg : 'https://bit.ly/3EoPFXM',
                leetcode : 'https://leetcode.com/problems/count-complete-tree-nodes/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '13.3-8',
                subTopic : 'Hard Problems',
                qnTitle : 'Requirements needed to construct a Unique Binary Tree | Theory',
                gfg : 'https://bit.ly/3UVCR1U',
                leetcode : null,
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '13.3-9',
                subTopic : 'Hard Problems',
                qnTitle : 'Construct Binary Tree from inorder and preorder',
                gfg : 'https://bit.ly/3AoZ4N5',
                leetcode : 'https://leetcode.com/problems/construct-binary-tree-from-preorder-and-inorder-traversal/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '13.3-10',
                subTopic : 'Hard Problems',
                qnTitle : '	Construct the Binary Tree from Postorder and Inorder Traversal',
                gfg : 'https://bit.ly/3wbFiTI',
                leetcode : 'https://leetcode.com/problems/construct-binary-tree-from-inorder-and-postorder-traversal/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '13.3-11',
                subTopic : 'Hard Problems',
                qnTitle : 'Serialize and deserialize Binary Tree',
                gfg : 'https://bit.ly/3PqPDSE',
                leetcode : 'https://leetcode.com/problems/serialize-and-deserialize-binary-tree/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '13.3-12',
                subTopic : 'Hard Problems',
                qnTitle : 'Morris Preorder Traversal of a Binary Tree',
                gfg : 'https://bit.ly/3EORTB9',
                leetcode : 'https://leetcode.com/problems/binary-tree-inorder-traversal/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '13.3-13',
                subTopic : 'Hard Problems',
                qnTitle : 'Morris Inorder Traversal of a Binary Tree',
                gfg : 'https://bit.ly/3tJQiGk',
                leetcode : 'https://leetcode.com/problems/binary-tree-inorder-traversal/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '13.3-14',
                subTopic : 'Hard Problems',
                qnTitle : 'Flatten Binary Tree to LinkedList',
                gfg : 'https://bit.ly/3PFzwko',
                leetcode : 'https://leetcode.com/problems/flatten-binary-tree-to-linked-list/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            }
        ]
    },
    'Binary Search Trees' : {
        'Concepts' : [
            {
                id : '14.1-1',
                subTopic : 'Concepts',
                qnTitle : 'Introduction to Binary Search Tree',
                gfg : 'https://bit.ly/3gprRLk',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            } ,
            {
                id : '14.1-2',
                subTopic : 'Concepts',
                qnTitle : 'Search in a Binary Search Tree',
                gfg : 'https://bit.ly/3Bwj68U',
                leetcode : 'https://leetcode.com/problems/search-in-a-binary-search-tree/',
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '14.1-3',
                subTopic : 'Concepts',
                qnTitle : 'Find Min/Max in BST',
                gfg : 'https://bit.ly/3f9XkzZ',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            } 
        ],
        'Practice Problems' : [
            {
                id : '14.2-1',
                subTopic : 'Practice Problems',
                qnTitle : 'Ceil in a Binary Search Tree',
                gfg : 'https://bit.ly/3BULqTJ',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '14.2-2',
                subTopic : 'Practice Problems',
                qnTitle : 'Floor in a Binary Search Tree',
                gfg : 'https://bit.ly/3TSbXXE',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '14.2-3',
                subTopic : 'Practice Problems',
                qnTitle : 'Insert a given Node in Binary Search Tree',
                gfg : 'https://bit.ly/3SoX3aH',
                leetcode : 'https://leetcode.com/problems/insert-into-a-binary-search-tree/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            } ,
            {
                id : '14.2-4',
                subTopic : 'Practice Problems',
                qnTitle : 'Delete a Node in Binary Search Tree',
                gfg : 'https://bit.ly/3dwYsxi',
                leetcode : 'https://leetcode.com/problems/delete-node-in-a-bst/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            } ,
            {
                id : '14.2-5',
                subTopic : 'Practice Problems',
                qnTitle : 'Find K-th smallest/largest element in BST',
                gfg : 'https://bit.ly/3LxFMdo',
                leetcode : 'https://leetcode.com/problems/kth-smallest-element-in-a-bst/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            } ,
            {
                id : '14.2-6',
                subTopic : 'Practice Problems',
                qnTitle : 'Check if a tree is a BST or BT',
                gfg : 'https://bit.ly/3poHDqN',
                leetcode : 'https://leetcode.com/problems/validate-binary-search-tree/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            } ,
            {
                id : '14.2-7',
                subTopic : 'Practice Problems',
                qnTitle : 'LCA in Binary Search Tree',
                gfg : 'https://bit.ly/3qRwTC1',
                leetcode : 'https://leetcode.com/problems/lowest-common-ancestor-of-a-binary-search-tree/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            } ,
            {
                id : '14.2-8',
                subTopic : 'Practice Problems',
                qnTitle : 'Construct a BST from a preorder traversal',
                gfg : 'https://bit.ly/3BSI1Un',
                leetcode : 'https://leetcode.com/problems/construct-binary-search-tree-from-preorder-traversal/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            } ,
            {
                id : '14.2-9',
                subTopic : 'Practice Problems',
                qnTitle : 'Inorder Successor/Predecessor in BST',
                gfg : 'https://practice.geeksforgeeks.org/problems/predecessor-and-successor/1',
                leetcode : 'https://leetcode.com/problems/inorder-successor-in-bst/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            } ,
            {
                id : '14.2-10',
                subTopic : 'Practice Problems',
                qnTitle : 'Merge 2 BST’s',
                gfg : 'https://bit.ly/3qWZrtS',
                leetcode : 'https://leetcode.com/problems/binary-search-tree-iterator/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            } ,
            {
                id : '14.2-11',
                subTopic : 'Practice Problems',
                qnTitle : 'Two Sum In BST | Check if there exists a pair with Sum K',
                gfg : 'https://bit.ly/3BUyCg6',
                leetcode : 'https://leetcode.com/problems/two-sum-iv-input-is-a-bst/',
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            } ,
            {
                id : '14.2-12',
                subTopic : 'Practice Problems',
                qnTitle : 'Recover BST | Correct BST with two nodes swapped',
                gfg : 'https://bit.ly/3PBJwea',
                leetcode : 'https://leetcode.com/problems/recover-binary-search-tree/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            } ,
            {
                id : '14.2-13',
                subTopic : 'Practice Problems',
                qnTitle : 'Largest BST in Binary Tree',
                gfg : 'https://bit.ly/3LxECPd',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            } 
        ]
    },
    'Graphs' : {
        'Learning' : [
            {
                id : '15.1-1',
                subTopic : 'Learning',
                qnTitle : 'Graph and Types',
                gfg : 'https://bit.ly/3gpY19t',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '15.1-2',
                subTopic : 'Learning',
                qnTitle : 'Graph Representation | C++',
                gfg : 'https://bit.ly/3dGuwyv',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '15.1-3',
                subTopic : 'Learning',
                qnTitle : '	Graph Representation | Java',
                gfg : 'https://bit.ly/3dGuwyv',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '15.1-4',
                subTopic : 'Learning',
                qnTitle : 'Connected Components | Logic Explanation',
                gfg : 'https://bit.ly/3AxzhDG',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '15.1-5',
                subTopic : 'Learning',
                qnTitle : 'BFS',
                gfg : 'https://practice.geeksforgeeks.org/problems/bfs-traversal-of-graph/1?utm_source=youtube&utm_medium=collab_striver_ytdescription&utm_campaign=bfs_of_graph',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '15.1-6',
                subTopic : 'Learning',
                qnTitle : 'DFS',
                gfg : 'https://practice.geeksforgeeks.org/problems/depth-first-traversal-for-a-graph/1?utm_source=youtube&utm_medium=collab_striver_ytdescription&utm_campaign=dfs_of_graph',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            } 
        ],
        'Problems on BFS/DFS' : [
            {
                id : '15.2-1',
                subTopic : 'Problems on BFS/DFS',
                qnTitle : 'Number of provinces (leetcode)',
                gfg : 'https://practice.geeksforgeeks.org/problems/number-of-provinces/1?utm_source=youtube&utm_medium=collab_striver_ytdescription&utm_campaign=number_of_provinces',
                leetcode : 'https://leetcode.com/problems/number-of-provinces/#:~:text=A%20province%20is%20a%20group,the%20total%20number%20of%20provinces.',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            } ,
            {
                id : '15.2-2',
                subTopic : 'Problems on BFS/DFS',
                qnTitle : 'Connected Components Problem in Matrix',
                gfg : 'https://bit.ly/3AxzhDG',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '15.2-3',
                subTopic : 'Problems on BFS/DFS',
                qnTitle : 'Rotten Oranges',
                gfg : 'https://practice.geeksforgeeks.org/problems/rotten-oranges2536/1?utm_source=youtube&utm_medium=collab_striver_ytdescription&utm_campaign=rotten_oranges',
                leetcode : 'https://leetcode.com/problems/rotting-oranges/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '15.2-4',
                subTopic : 'Problems on BFS/DFS',
                qnTitle : 'Flood fill',
                gfg : 'https://practice.geeksforgeeks.org/problems/flood-fill-algorithm1856/1?utm_source=youtube&utm_medium=collab_striver_ytdescription&utm_campaign=flood-fill-algorithm',
                leetcode : 'https://leetcode.com/problems/flood-fill/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '15.2-5',
                subTopic : 'Problems on BFS/DFS',
                qnTitle : 'Cycle Detection in unirected Graph (bfs)',
                gfg : 'https://practice.geeksforgeeks.org/problems/detect-cycle-in-an-undirected-graph/1?utm_source=youtube&utm_medium=collab_striver_ytdescription&utm_campaign=detect-cycle-in-an-undirected-graph',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '15.2-6',
                subTopic : 'Problems on BFS/DFS',
                qnTitle : 'Cycle Detection in undirected Graph (dfs)',
                gfg : 'https://practice.geeksforgeeks.org/problems/detect-cycle-in-an-undirected-graph/1?utm_source=youtube&utm_medium=collab_striver_ytdescription&utm_campaign=detect-cycle-in-an-undirected-graph',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '15.2-7',
                subTopic : 'Problems on BFS/DFS',
                qnTitle : '0/1 Matrix (Bfs Problem)',
                gfg : 'https://bit.ly/3Lw8Emp',
                leetcode : 'https://leetcode.com/problems/01-matrix/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '15.2-8',
                subTopic : 'Problems on BFS/DFS',
                qnTitle : 'Surrounded Regions (dfs)',
                gfg : 'https://bit.ly/3T3oDLR',
                leetcode : 'https://leetcode.com/problems/surrounded-regions/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '15.2-9',
                subTopic : 'Problems on BFS/DFS',
                qnTitle : '	Number of Enclaves [flood fill implementation – multisource]',
                gfg : 'https://bit.ly/3LA59uX',
                leetcode : 'https://leetcode.com/problems/number-of-enclaves/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '15.2-10',
                subTopic : 'Problems on BFS/DFS',
                qnTitle : 'Word ladder – 1',
                gfg : 'https://bit.ly/3BE8tke',
                leetcode : 'https://leetcode.com/problems/word-ladder/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '15.2-11',
                subTopic : 'Problems on BFS/DFS',
                qnTitle : 'Word ladder – 2',
                gfg : 'https://bit.ly/3fdDxzC',
                leetcode : 'https://leetcode.com/problems/word-ladder-ii/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '15.2-12',
                subTopic : 'Problems on BFS/DFS',
                qnTitle : 'Number of Distinct Islands [dfs multisource]',
                gfg : 'https://practice.geeksforgeeks.org/problems/number-of-distinct-islands/1',
                leetcode : 'https://leetcode.com/problems/number-of-distinct-islands-ii/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '15.2-13',
                subTopic : 'Problems on BFS/DFS',
                qnTitle : 'Bipartite Graph (DFS)',
                gfg : 'https://bit.ly/3QZN2jf',
                leetcode : 'https://leetcode.com/problems/is-graph-bipartite/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '15.2-14',
                subTopic : 'Problems on BFS/DFS',
                qnTitle : 'Cycle Detection in Directed Graph (DFS)',
                gfg : 'https://bit.ly/3S01qt8',
                leetcode : 'https://leetcode.com/problems/course-schedule-ii/discuss/293048/detecting-cycle-in-directed-graph-problem',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            }
        ],
        'Topo Sort and Problems' : [
            {
                id : '15.3-1',
                subTopic : 'Topo Sort and Problems',
                qnTitle : 'Topo Sort',
                gfg : 'https://bit.ly/3S02dKC',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '15.3-2',
                subTopic : 'Topo Sort and Problems',
                qnTitle : 'Kahn’s Algorithm',
                gfg : 'https://bit.ly/3c690mm',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '15.3-3',
                subTopic : 'Topo Sort and Problems',
                qnTitle : 'Cycle Detection in Directed Graph (BFS)',
                gfg : 'https://bit.ly/3DK3elS',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '15.3-4',
                subTopic : 'Topo Sort and Problems',
                qnTitle : 'Course Schedule – I',
                gfg : 'https://bit.ly/3SpUd5m',
                leetcode : 'https://leetcode.com/problems/course-schedule/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '15.3-5',
                subTopic : 'Topo Sort and Problems',
                qnTitle : '	Course Schedule – II',
                gfg : 'https://bit.ly/3w8ZBBl',
                leetcode : 'https://leetcode.com/problems/course-schedule-ii/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '15.3-6',
                subTopic : 'Topo Sort and Problems',
                qnTitle : 'Find eventual safe states',
                gfg : 'https://bit.ly/3S6TE0w',
                leetcode : 'https://leetcode.com/problems/find-eventual-safe-states/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '15.3-7',
                subTopic : 'Topo Sort and Problems',
                qnTitle : 'Alien dictionary',
                gfg : 'https://bit.ly/3LwfXdP',
                leetcode : 'https://leetcode.com/problems/alien-dictionary/solution/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            }
        ],
        'Shortest Path Algorithms and Problems' : [
            {
                id : '15.4-1',
                subTopic : 'Shortest Path Algorithms and Problems',
                qnTitle : 'Shortest Path in UG with unit weights',
                gfg : 'https://bit.ly/3UVQD4C',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '15.4-2',
                subTopic : 'Shortest Path Algorithms and Problems',
                qnTitle : 'Shortest Path in DAG',
                gfg : 'https://bit.ly/3Eo1mhq',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '15.4-3',
                subTopic : 'Shortest Path Algorithms and Problems',
                qnTitle : 'Djisktra’s Algorithm',
                gfg : 'https://bit.ly/3UsjnST',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '15.4-4',
                subTopic : 'Shortest Path Algorithms and Problems',
                qnTitle : 'Why priority Queue is used in Djisktra’s Algorithm',
                gfg : 'https://bit.ly/3UsjnST',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '15.4-5',
                subTopic : 'Shortest Path Algorithms and Problems',
                qnTitle : 'Shortest path in a binary maze',
                gfg : 'https://bit.ly/3ArrkzD',
                leetcode : 'https://leetcode.com/problems/shortest-path-in-binary-matrix/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '15.4-6',
                subTopic : 'Shortest Path Algorithms and Problems',
                qnTitle : 'Path with minimum effort',
                gfg : 'https://bit.ly/3OpIfbh',
                leetcode : 'https://leetcode.com/problems/path-with-minimum-effort/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '15.4-7',
                subTopic : 'Shortest Path Algorithms and Problems',
                qnTitle : 'Cheapest flights within k stops',
                gfg : 'https://bit.ly/3OnPWi4',
                leetcode : 'https://leetcode.com/problems/cheapest-flights-within-k-stops/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '15.4-8',
                subTopic : 'Shortest Path Algorithms and Problems',
                qnTitle : 'Network Delay time',
                gfg : 'https://bit.ly/3pr6ObZ',
                leetcode : 'https://leetcode.com/problems/network-delay-time/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '15.4-9',
                subTopic : 'Shortest Path Algorithms and Problems',
                qnTitle : 'Number of ways to arrive at destination',
                gfg : 'https://bit.ly/3Soi85j-arrive-at-destination/1',
                leetcode : 'https://leetcode.com/problems/number-of-ways-to-arrive-at-destination/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '15.4-10',
                subTopic : 'Shortest Path Algorithms and Problems',
                qnTitle : 'Minimum steps to reach end from start by performing multiplication and mod operations with array elements',
                gfg : 'https://bit.ly/3QAEsrY',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '15.4-11',
                subTopic : 'Shortest Path Algorithms and Problems',
                qnTitle : 'Bellman Ford Algorithm',
                gfg : 'https://bit.ly/3C0SxKs',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '15.4-12',
                subTopic : 'Shortest Path Algorithms and Problems',
                qnTitle : 'Floyd Warshal Algorithm',
                gfg : 'https://bit.ly/3LwgdJP',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '15.4-13',
                subTopic : 'Shortest Path Algorithms and Problems',
                qnTitle : 'Find the city with the smallest number of neighbors in a threshold distance',
                gfg : 'https://bit.ly/3Lwr5Y4',
                leetcode : 'https://leetcode.com/problems/find-the-city-with-the-smallest-number-of-neighbors-at-a-threshold-distance/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            }
        ],
        'Minimum Spanning Tree/Disjoint Set' : [
            {
                id : '15.5-1',
                subTopic : 'Minimum Spanning Tree/Disjoint Set',
                qnTitle : '	Minimum Spanning Tree',
                gfg : 'https://bit.ly/3R2Xhn1',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '15.5-2',
                subTopic : 'Minimum Spanning Tree/Disjoint Set',
                qnTitle : 'Prim’s Algorithm',
                gfg : 'https://bit.ly/3R2Xhn1',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '15.5-3',
                subTopic : 'Minimum Spanning Tree/Disjoint Set',
                qnTitle : 'Disjoint Set [Union by Rank]',
                gfg : 'https://bit.ly/3QSGvHz',
                leetcode : null,
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '15.5-4',
                subTopic : 'Minimum Spanning Tree/Disjoint Set',
                qnTitle : 'Disjoint Set [Union by Size]',
                gfg : 'https://bit.ly/3QSGvHz',
                leetcode : null,
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '15.5-5',
                subTopic : 'Minimum Spanning Tree/Disjoint Set',
                qnTitle : 'Kruskal’s Algorithm',
                gfg : 'https://bit.ly/3R2Xhn1',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '15.5-6',
                subTopic : 'Minimum Spanning Tree/Disjoint Set',
                qnTitle : 'Number of operations to make network connected',
                gfg : 'https://bit.ly/3Esuzrd',
                leetcode : 'https://leetcode.com/problems/number-of-operations-to-make-network-connected/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '15.5-7',
                subTopic : 'Minimum Spanning Tree/Disjoint Set',
                qnTitle : 'Most stones removed with same rows or columns',
                gfg : 'https://bit.ly/3Ep4Tfo',
                leetcode : 'https://leetcode.com/problems/most-stones-removed-with-same-row-or-column/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '15.5-8',
                subTopic : 'Minimum Spanning Tree/Disjoint Set',
                qnTitle : 'Accounts merge',
                gfg : 'https://bit.ly/3C03qMi',
                leetcode : 'https://leetcode.com/problems/accounts-merge/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '15.5-9',
                subTopic : 'Minimum Spanning Tree/Disjoint Set',
                qnTitle : 'Number of island II',
                gfg : 'https://bit.ly/3A7BofH',
                leetcode : 'https://leetcode.com/problems/number-of-islands-ii/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '15.5-10',
                subTopic : 'Minimum Spanning Tree/Disjoint Set',
                qnTitle : 'Making a Large Island',
                gfg : 'https://bit.ly/3i1yOmk',
                leetcode : 'https://leetcode.com/problems/making-a-large-island/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '15.5-11',
                subTopic : 'Minimum Spanning Tree/Disjoint Set',
                qnTitle : 'Swim in rising water',
                gfg : 'https://bit.ly/3VftZ7i',
                leetcode : 'https://leetcode.com/problems/swim-in-rising-water/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            }
        ],
        'Other Algorithms' : [
            {
                id : '15.6-1',
                subTopic : 'Other Algorithms',
                qnTitle : 'Bridges in Graph',
                gfg : 'https://bit.ly/3dFdvVe',
                leetcode : 'https://leetcode.com/problems/critical-connections-in-a-network/discuss/382385/find-bridges-in-a-graph',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '15.6-2',
                subTopic : 'Other Algorithms',
                qnTitle : 'Articulation Point',
                gfg : 'https://bit.ly/3T2LPKu',
                leetcode : null,
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '15.6-3',
                subTopic : 'Other Algorithms',
                qnTitle : 'Kosaraju’s Algorithm',
                gfg : 'https://bit.ly/3TbvByL',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            } 
        ]
    },
    'Dynamic Programming' : {
        'Introduction to DP' : [
            {
                id : '16.1-1',
                subTopic : 'Introduction to DP',
                qnTitle : 'Dynamic Programming Introduction',
                gfg : 'https://bit.ly/3UWkWrS',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            } 
        ],
        '1D DP' : [
            {
                id : '16.2-1',
                subTopic : '1D DP',
                qnTitle : 'Climbing Stars',
                gfg : 'https://bit.ly/3DLrBQ2',
                leetcode : 'https://leetcode.com/problems/climbing-stairs/',
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '16.2-2',
                subTopic : '1D DP',
                qnTitle : 'Frog Jump(DP-3)',
                gfg : 'https://bit.ly/3Xn0Kkw',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            } ,
            {
                id : '16.2-3',
                subTopic : '1D DP',
                qnTitle : 'Frog Jump with k distances(DP-4)',
                gfg : 'https://bit.ly/3GyNRya',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            } ,
            {
                id : '16.2-4',
                subTopic : '1D DP',
                qnTitle : 'Maximum sum of non-adjacent elements (DP 5)',
                gfg : 'https://bit.ly/3QOMRs1',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            } ,
            {
                id : '16.2-5',
                subTopic : '1D DP',
                qnTitle : 'House Robber (DP 6)',
                gfg : 'https://bit.ly/3QCCpDQ',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            }  
        ],
        '2D/3D DP and DP on Grids' : [
            {
                id : '16.3-1',
                subTopic : '2D/3D DP and DP on Grids',
                qnTitle : 'Ninja’s Training (DP 7)',
                gfg : 'https://bit.ly/3glc9kp',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '16.3-2',
                subTopic : '2D/3D DP and DP on Grids',
                qnTitle : 'Grid Unique Paths : DP on Grids (DP8)',
                gfg : 'https://bit.ly/3BsNkJO',
                leetcode : 'https://leetcode.com/problems/unique-paths/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '16.3-3',
                subTopic : '2D/3D DP and DP on Grids',
                qnTitle : 'Grid Unique Paths 2 (DP 9)',
                gfg : 'https://bit.ly/3tNYlBU',
                leetcode : 'https://leetcode.com/problems/unique-paths-ii/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '16.3-4',
                subTopic : '2D/3D DP and DP on Grids',
                qnTitle : 'Minimum path sum in Grid (DP 10)',
                gfg : 'https://bit.ly/3c1H9Uf',
                leetcode : 'https://leetcode.com/problems/minimum-path-sum/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '16.3-5',
                subTopic : '2D/3D DP and DP on Grids',
                qnTitle : 'Minimum path sum in Triangular Grid (DP 11)',
                gfg : 'https://bit.ly/3VaQIkI',
                leetcode : 'https://leetcode.com/problems/triangle/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '16.3-6',
                subTopic : '2D/3D DP and DP on Grids',
                qnTitle : 'Minimum/Maximum Falling Path Sum (DP-12)',
                gfg : 'https://bit.ly/3PwqvtO',
                leetcode : 'https://leetcode.com/problems/minimum-falling-path-sum/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '16.3-7',
                subTopic : '2D/3D DP and DP on Grids',
                qnTitle : '3-d DP : Ninja and his friends (DP-13)',
                gfg : 'https://bit.ly/3U9k6XT',
                leetcode : null,
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            }
        ],
        'DP on Subsequences' : [
            {
                id : '16.4-1',
                subTopic : 'DP on Subsequences',
                qnTitle : 'Subset sum equal to target (DP- 14)',
                gfg : 'https://bit.ly/3S6ljPd',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '16.4-2',
                subTopic : 'DP on Subsequences',
                qnTitle : 'Partition Equal Subset Sum (DP- 15)',
                gfg : 'https://bit.ly/3E14123',
                leetcode : 'https://leetcode.com/problems/partition-equal-subset-sum/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '16.4-3',
                subTopic : 'DP on Subsequences',
                qnTitle : 'Partition Set Into 2 Subsets With Min Absolute Sum Diff (DP- 16)',
                gfg : 'https://bit.ly/3S6uVtg',
                leetcode : 'https://leetcode.com/problems/partition-array-into-two-arrays-to-minimize-sum-difference/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '16.4-4',
                subTopic : 'DP on Subsequences',
                qnTitle : 'Count Subsets with Sum K (DP – 17)',
                gfg : 'https://bit.ly/3AwVr8I',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '16.4-5',
                subTopic : 'DP on Subsequences',
                qnTitle : 'Count Partitions with Given Difference (DP – 18)',
                gfg : 'https://bit.ly/3gkAM0s',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '16.4-6',
                subTopic : 'DP on Subsequences',
                qnTitle : '0/1 Knapsack (DP – 19)',
                gfg : 'https://bit.ly/3BZTjXT',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '16.4-7',
                subTopic : 'DP on Subsequences',
                qnTitle : 'Minimum Coins (DP – 20)',
                gfg : 'https://bit.ly/3UG0egq',
                leetcode : 'https://leetcode.com/problems/coin-change/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '16.4-8',
                subTopic : 'DP on Subsequences',
                qnTitle : 'Target Sum (DP – 21)',
                gfg : 'https://bit.ly/3BxB2jr',
                leetcode : 'https://leetcode.com/problems/target-sum/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '16.4-9',
                subTopic : 'DP on Subsequences',
                qnTitle : 'Coin Change 2 (DP – 22)',
                gfg : 'https://bit.ly/3SZJWOl',
                leetcode : 'https://leetcode.com/problems/coin-change-2/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '16.4-10',
                subTopic : 'DP on Subsequences',
                qnTitle : 'Unbounded Knapsack (DP – 23)',
                gfg : 'https://bit.ly/3Cbc5fz',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '16.4-11',
                subTopic : 'DP on Subsequences',
                qnTitle : 'Rod Cutting Problem | (DP – 24)',
                gfg : 'https://bit.ly/3R1TXZh',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            }
        ],
        'DP on Strings' : [
            {
                id : '16.5-1',
                subTopic : 'DP on Strings',
                qnTitle : 'Longest Common Subsequence | (DP – 25)',
                gfg : 'https://bit.ly/3f6eDlE',
                leetcode : 'https://leetcode.com/problems/longest-common-subsequence/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '16.5-2',
                subTopic : 'DP on Strings',
                qnTitle : 'Print Longest Common Subsequence | (DP – 26)',
                gfg : 'https://bit.ly/3T1Va4U',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '16.5-3',
                subTopic : 'DP on Strings',
                qnTitle : '	Longest Common Substring | (DP – 27)',
                gfg : 'https://bit.ly/3qYUeBK',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '16.5-4',
                subTopic : 'DP on Strings',
                qnTitle : 'Longest Palindromic Subsequence | (DP-28)',
                gfg : 'https://bit.ly/3SndYdP',
                leetcode : 'https://leetcode.com/problems/longest-palindromic-subsequence/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '16.5-5',
                subTopic : 'DP on Strings',
                qnTitle : '	Minimum insertions to make string palindrome | DP-29',
                gfg : 'https://bit.ly/3S6ekWx',
                leetcode : 'https://leetcode.com/problems/minimum-insertion-steps-to-make-a-string-palindrome/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '16.5-6',
                subTopic : 'DP on Strings',
                qnTitle : 'Minimum Insertions/Deletions to Convert String | (DP- 30)',
                gfg : 'https://bit.ly/3UwoktW',
                leetcode : 'https://leetcode.com/problems/delete-operation-for-two-strings/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '16.5-7',
                subTopic : 'DP on Strings',
                qnTitle : 'Shortest Common Supersequence | (DP – 31)',
                gfg : 'https://bit.ly/3R8AIxc',
                leetcode : 'https://leetcode.com/problems/shortest-common-supersequence/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '16.5-8',
                subTopic : 'DP on Strings',
                qnTitle : 'Distinct Subsequences| (DP-32)',
                gfg : 'https://bit.ly/3Lz0Wry',
                leetcode : 'https://leetcode.com/problems/distinct-subsequences/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '16.5-9',
                subTopic : 'DP on Strings',
                qnTitle : 'Edit Distance | (DP-33)',
                gfg : 'https://bit.ly/3qZueWY',
                leetcode : 'https://leetcode.com/problems/edit-distance/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '16.5-10',
                subTopic : 'DP on Strings',
                qnTitle : 'Wildcard Matching | (DP-34)',
                gfg : 'https://bit.ly/3R2Zfnp',
                leetcode : 'https://leetcode.com/problems/wildcard-matching/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            }
        ],
        'DP on Stocks' : [
            {
                id : '16.6-1',
                subTopic : 'DP on Stocks',
                qnTitle : 'Best Time to Buy and Sell Stock |(DP-35)',
                gfg : 'https://bit.ly/3xI7ajb',
                leetcode : 'https://leetcode.com/problems/best-time-to-buy-and-sell-stock/',
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '16.6-2',
                subTopic : 'DP on Stocks',
                qnTitle : 'Buy and Sell Stock – II|(DP-36)',
                gfg : 'https://bit.ly/3gkV5en',
                leetcode : 'https://leetcode.com/problems/best-time-to-buy-and-sell-stock-ii/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '16.6-3',
                subTopic : 'DP on Stocks',
                qnTitle : 'Buy and Sell Stocks III|(DP-37)',
                gfg : 'https://bit.ly/3qZaYZs',
                leetcode : 'https://leetcode.com/problems/best-time-to-buy-and-sell-stock-iii/description/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '16.6-4',
                subTopic : 'DP on Stocks',
                qnTitle : 'Buy and Stock Sell IV |(DP-38)',
                gfg : 'https://bit.ly/3SpU1TE',
                leetcode : 'https://leetcode.com/problems/best-time-to-buy-and-sell-stock-iv/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '16.6-5',
                subTopic : 'DP on Stocks',
                qnTitle : 'Buy and Sell Stocks With Cooldown|(DP-39)',
                gfg : 'https://bit.ly/3GycvyA',
                leetcode : 'https://leetcode.com/problems/best-time-to-buy-and-sell-stock-with-cooldown/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '16.6-6',
                subTopic : 'DP on Stocks',
                qnTitle : 'Buy and Sell Stocks With Transaction Fee|(DP-40)',
                gfg : 'https://bit.ly/3AwUkpe',
                leetcode : 'https://leetcode.com/problems/best-time-to-buy-and-sell-stock-with-transaction-fee/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            }
        ],
        'DP on LIS' : [
            {
                id : '16.7-1',
                subTopic : 'DP on LIS',
                qnTitle : 'Longest Increasing Subsequence |(DP-41)',
                gfg : 'https://bit.ly/3eYunab',
                leetcode : 'https://leetcode.com/problems/longest-increasing-subsequence/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '16.7-2',
                subTopic : 'DP on LIS',
                qnTitle : 'Printing Longest Increasing Subsequence|(DP-42)',
                gfg : 'https://bit.ly/3XiRbmG',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '16.7-3',
                subTopic : 'DP on LIS',
                qnTitle : 'Longest Increasing Subsequence |(DP-43)',
                gfg : 'https://bit.ly/3Pxf84L',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '16.7-4',
                subTopic : 'DP on LIS',
                qnTitle : 'Largest Divisible Subset|(DP-44)',
                gfg : 'https://bit.ly/3hYsWKC',
                leetcode : 'https://leetcode.com/problems/largest-divisible-subset/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '16.7-5',
                subTopic : 'DP on LIS',
                qnTitle : 'Longest String Chain|(DP-45)',
                gfg : 'https://bit.ly/3TSqOkS',
                leetcode : 'https://leetcode.com/problems/longest-string-chain/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '16.7-6',
                subTopic : 'DP on LIS',
                qnTitle : 'Longest Bitonic Subsequence |(DP-46)',
                gfg : 'https://bit.ly/3BARIGF',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '16.7-7',
                subTopic : 'DP on LIS',
                qnTitle : 'Number of Longest Increasing Subsequences|(DP-47)',
                gfg : 'https://bit.ly/3EohD60',
                leetcode : 'https://leetcode.com/problems/number-of-longest-increasing-subsequence/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            }
        ],
        'MCM DP | Partition DP' : [
            {
                id : '16.8-1',
                subTopic : 'MCM DP | Partition DP',
                qnTitle : 'Matrix Chain Multiplication|(DP-48)',
                gfg : 'https://bit.ly/3Cgg36D',
                leetcode : null,
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '16.8-2',
                subTopic : 'MCM DP | Partition DP',
                qnTitle : 'Matrix Chain Multiplication | Bottom-Up|(DP-49)',
                gfg : 'https://bit.ly/3Cgg36D',
                leetcode : null,
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '16.8-3',
                subTopic : 'MCM DP | Partition DP',
                qnTitle : 'Minimum Cost to Cut the Stick|(DP-50)',
                gfg : 'https://bit.ly/3K3ItCE',
                leetcode : 'https://leetcode.com/problems/minimum-cost-to-cut-a-stick/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '16.8-4',
                subTopic : 'MCM DP | Partition DP',
                qnTitle : 'Burst Balloons|(DP-51)',
                gfg : 'https://bit.ly/3A9LdKp',
                leetcode : 'https://leetcode.com/problems/burst-balloons/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '16.8-5',
                subTopic : 'MCM DP | Partition DP',
                qnTitle : 'Evaluate Boolean Expression to True|(DP-52)',
                gfg : 'https://bit.ly/3QFAe2o',
                leetcode : 'https://leetcode.com/problems/parsing-a-boolean-expression/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '16.8-6',
                subTopic : 'MCM DP | Partition DP',
                qnTitle : 'Palindrome Partitioning – II|(DP-53)',
                gfg : 'https://bit.ly/3QP6gsc',
                leetcode : 'https://leetcode.com/problems/palindrome-partitioning-ii/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '16.8-7',
                subTopic : 'MCM DP | Partition DP',
                qnTitle : 'Partition Array for Maximum Sum|(DP-54)',
                gfg : 'https://bit.ly/3AUSIGj',
                leetcode : 'https://leetcode.com/problems/partition-array-for-maximum-sum/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            }
        ],
        'DP on Squares' : [
            {
                id : '16.9-1',
                subTopic : 'DP on Squares',
                qnTitle : 'Maximum Rectangle Area with all 1’s|(DP-55)',
                gfg : 'https://bit.ly/3BY0ShY',
                leetcode : 'https://leetcode.com/problems/maximal-rectangle/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '16.9-1',
                subTopic : 'DP on Squares',
                qnTitle : 'Count Square Submatrices with All Ones|(DP-56)',
                gfg : 'https://bit.ly/3UW7u7o',
                leetcode : 'https://leetcode.com/problems/count-square-submatrices-with-all-ones/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            }
        ]
    },
    'Tries' : {
        'Theory' : [
            {
                id : '17.1-1',
                subTopic : 'Theory',
                qnTitle : 'Implement TRIE | INSERT | SEARCH | STARTSWITH',
                gfg : 'https://bit.ly/3pqacEj',
                leetcode : 'https://leetcode.com/problems/implement-trie-prefix-tree/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            }
        ],
        'Problems' : [
            {
                id : '17.2-1',
                subTopic : 'Problems',
                qnTitle : 'Implement Trie – 2 (Prefix Tree)',
                gfg : 'https://bit.ly/3SUAiwJ',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '17.2-2',
                subTopic : 'Problems',
                qnTitle : 'Longest String with All Prefixes',
                gfg : 'https://bit.ly/3Qx5AYB',
                leetcode : null,
                difficulty : 'easy',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '17.2-3',
                subTopic : 'Problems',
                qnTitle : 'Number of Distinct Substrings in a String',
                gfg : 'https://bit.ly/3UoqdsB',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '17.2-4',
                subTopic : 'Problems',
                qnTitle : 'Bit PreRequisites for TRIE Problems',
                gfg : 'https://bit.ly/3Vw4XB1',
                leetcode : null,
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '17.2-5',
                subTopic : 'Problems',
                qnTitle : 'Maximum XOR of two numbers in an array',
                gfg : 'https://bit.ly/3Bypqwp',
                leetcode : 'https://leetcode.com/problems/maximum-xor-of-two-numbers-in-an-array/',
                difficulty : 'medium',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '17.2-6',
                subTopic : 'Problems',
                qnTitle : 'Maximum XOR With an Element From Array',
                gfg : 'https://bit.ly/3tNYB3Y',
                leetcode : 'https://leetcode.com/problems/maximum-xor-with-an-element-from-array/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            }
        ]
    },
    'Strings [Hard Problems and Standard Algos]' : {
        'Hard Problems' : [
            {
                id : '18.1-1',
                subTopic : 'Hard Problems',
                qnTitle : 'Minimum number of bracket reversals needed to make an expression balanced',
                gfg : 'https://bit.ly/3RiQ82d',
                leetcode : 'https://leetcode.com/problems/minimum-add-to-make-parentheses-valid/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '18.1-2',
                subTopic : 'Hard Problems',
                qnTitle : 'Count and say',
                gfg : 'https://bit.ly/3AFdLwR',
                leetcode : 'https://leetcode.com/problems/count-and-say/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '18.1-3',
                subTopic : 'Hard Problems',
                qnTitle : 'Hashing In Strings | Theory',
                gfg : 'https://bit.ly/3glak75',
                leetcode : null,
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '18.1-4',
                subTopic : 'Hard Problems',
                qnTitle : 'Rabin Karp',
                gfg : 'https://bit.ly/3SkQqGw',
                leetcode : null,
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '18.1-5',
                subTopic : 'Hard Problems',
                qnTitle : 'Z-Function',
                gfg : 'https://bit.ly/3dBLAGb',
                leetcode : null,
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '18.1-6',
                subTopic : 'Hard Problems',
                qnTitle : 'KMP algo / LPS(pi) array',
                gfg : 'https://bit.ly/3fdJzQM',
                leetcode : null,
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '18.1-7',
                subTopic : 'Hard Problems',
                qnTitle : 'Shortest Palindrome',
                gfg : 'https://bit.ly/3PxCaIE',
                leetcode : 'https://leetcode.com/problems/shortest-palindrome/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '18.1-8',
                subTopic : 'Hard Problems',
                qnTitle : 'Longest happy prefix',
                gfg : 'https://bit.ly/3ptCpKi',
                leetcode : 'https://leetcode.com/problems/longest-happy-prefix/',
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            },
            {
                id : '18.1-9',
                subTopic : 'Hard Problems',
                qnTitle : 'Count palindromic subsequence in given string',
                gfg : 'https://bit.ly/3xHw6Hs',
                leetcode : null,
                difficulty : 'hard',
                brute : false,
                better : false,
                optimal : false
            }
        ]
    }
}